import BattleZone from '../entities/BattleZone.js';
import PCLocation from '../entities/PCLocation.js';
import WaterEntryZone from '../entities/WaterEntryZone.js';
import LandEntryZone from '../entities/LandEntryZone.js';
import Boundary from '../entities/Boundary.js';
import RightLedge from '../entities/RightLedge.js';
import LeftLedge from '../entities/LeftLedge.js';
import DownLedge from '../entities/DownLedge.js';
import NPC from '../entities/NPC.js';
import WarpZone from '../entities/WarpZone.js';
import EventTrigger from '../entities/EventTrigger.js';
import TeleportLocation from '../entities/TeleportLocation.js';
import LocationIndicatorZone from '../entities/LocationIndicatorZone.js';
import Location from '../entities/Location.js';
import HealingLocation from '../entities/HealingLocation.js';
import MartLocation from '../entities/MartLocation.js';
import TextSource from '../entities/TextSource.js';
import VerticalPositionControl from '../entities/VerticalPositionControl.js';
import DiagonalMovementControl from '../entities/DiagonalMovementControl.js';
import OverworldItem from '../entities/OverworldItem.js';
import HMTree from '../entities/HMTree.js';
import HMRock from '../entities/HMRock.js';
import GameMap from '../entities/GameMap.js';
import ItemFactory from '../entities/ItemFactory.js';
import Trainer from '../entities/Trainer.js';
import Pokemon from '../entities/Pokemon.js';
import OverworldAction from '../entities/OverworldAction.js';
import BattleGUI from '../entities/BattleGUI.js';
import BattleStateMachine from './BattleStateMachine.js';
import OverworldDecoration from '../entities/OverworldDecoration.js';
import HM from '../entities/HM.js';
import Player from '../entities/Player.js';
import MenuHandler from '../entities/MenuHandler.js';
import SaveFileMenu from '../entities/SaveFileMenu.js';
import BagMenuBackEnd from '../entities/menus/BagMenu.js';
import YesOrNoMenu from '../entities/menus/YesOrNoMenu.js';
import PlayerGenderMenu from '../entities/PlayerGenderMenu.js';
import StaticEncounter from '../entities/StaticEncounter.js';
import BaseEvent from '../entities/events/BaseEvent.js';
import StarterPokemonPokeball from '../entities/StarterPokemonPokeball.js';
import {
    IDLE,
    START_MOVING,
    MOVING,
    SAVE_FILE_SELECT,
    INTRO_CREDITS,
    SAVE_FILE_INCOMPATIBLE,
    NEW_FILE_STARTED,
    USE_KEYBOARD,
    SET_PLAYER_NAME,
    WARP_TO_LOCATION,
    CHANGE_DIRECTION,
    END_MOVING,
    READ_TEXT_SOURCE,
    BOOT_UP_PC,
    MANAGE_POKEMON,
    CANT_LEAVE_PC_WITHOUT_POKEMON,
    MANAGE_POKEMON_WITH_SELECTED,
    PC_POKEMON_PRESELECTED,
    RELEASE_POKEMON,
    SHUT_DOWN_PC,
    INTERACT_WITH_MART_LOCATION,
    CHOOSE_MART_OPTION,
    BUY_FROM_MART,
    MART_OPTION_PRESELECTED,
    MART_OPTION_SELECT_AMOUNT,
    MART_NOT_ENOUGH_MONEY,
    MART_ITEM_AMOUNT_SELECTED,
    MART_ITEM_AMOUNT_CONFIRMED,
    MART_ANYTHING_ELSE,
    SELL_TO_MART,
    CANT_SELL_THIS_ITEM,
    MART_SELL_AMOUNT,
    MART_SELL_AMOUNT_CONFIRMATION,
    MART_ITEMS_SOLD,
    END_MART_INTERACTION,
    INTERACT_WITH_HEALING_LOCATION,
    INTERACT_WITH_NPC,
    INTERACT_WITH_HM_TREE,
    INTERACT_WITH_HM_ROCK,
    ACQUIRE_OVERWORLD_ITEM,
    COLLISION,
    START_BATTLE,
    START_TRAINER_BATTLE,
    BATTLE,
    END_BATTLE,
    EVOLVE_POKEMON,
    PAUSE_MENU,
    OPTIONS_MENU,
    POKEDEX,
    TRAINER_CARD,
    POKEMON,
    SWITCH_POSITIONS_WITH_WHO,
    POKEMON_SWITCH_POSITIONS,
    POKEMON_PRESELECTED,
    DO_WHAT_WITH_ITEM,
    POKEMON_SUMMARY,
    POKEMON_MOVE_DETAIL,
    BAG,
    BAG_ITEM_PRESELECTED,
    KEY_ITEM_PRESELECTED,
    USE_KEY_ITEM,
    TOWN_MAP,
    TOWN_MAP_LOCATION_DETAIL,
    CANT_USE_ITEM,
    SELECT_ITEM_RECIPIENT,
    ITEM_GIVEN_TO_POKEMON,
    ITEM_TAKEN_FROM_POKEMON,
    SELECT_ITEM_CONSUMER,
    SELECT_ITEM_CONSUMER_MOVE,
    SET_NICKNAME,
    APPLY_ITEM_TO_MOVE,
    APPLY_ITEM_TO_RECIPIENT,
    APPLY_EV_ITEM_TO_RECIPIENT,
    APPLY_RARE_CANDY,
    RARE_CANDY_APPLIED,
    MOVE_ITEM_APPLIED,
    HEALTH_ITEM_APPLIED,
    EV_ITEM_APPLIED,
    IT_WONT_HAVE_ANY_EFFECT,
    APPLY_HM_TO_RECIPIENT,
    NEW_MOVE_AVAILABLE,
    CONFIRM_LEARN_NEW_MOVE,
    CHOOSE_MOVE_TO_FORGET,
    FORGOT_MOVE,
    LEARNED_NEW_MOVE,
    STOP_LEARNING_NEW_MOVE,
    DID_NOT_LEARN_NEW_MOVE,
    SAVE,
    LOAD_GAME,
    LOADING,
    EXIT,
    SEEN_BY_TRAINER,
    APPROACHED_BY_TRAINER,
    USE_FLASH,
    OVERWORLD_EVENT,
    LEVEL_UP_POKEMON,
    UP,
    DOWN,
    LEFT,
    RIGHT,
    MOVE_N_STEPS,
    CURRENT_MOVES_FULL,
    PLAYER_SEEN,
    SELECT_PLAYER_GENDER,
    INTERACT_WITH_STATIC_ENCOUNTER,
    NEW_UNAUTHORIZED_SESSION_STARTED,
    SET_ACCESS_CODE,
    VERIFY_ACCESS_CODE,
    CHECK_AUTH,
    berryItemIds,
    pinchBerryItemIds,
} from '../constants.js';

import { ETT_ON_ENTER } from '../entities/EventTrigger.js';

import { trainerData } from '../data/trainerData.js';

import { globalItemDataStore } from '../OverworldAnimation.js';

import { keys } from '../setup.js';

import { spriteStore } from '../images.js';

import { gameSaveManager } from '../entities/GameSaveManager.js';

import { battleAnimationLoop } from '../BattleAnimation.js';

import {
    KPI_A,
    KPI_S,
    KPI_D,
    KPI_W,
    KPI_L,
    KPI_K,
    KPI___,
    availableMaps,
    getGUI,
} from '../OverworldAnimation.js';
import KeyboardMenu from '../entities/KeyboardMenu.js';
import PauseMenu from '../entities/PauseMenu.js';
import OptionsMenu from '../entities/OptionsMenu.js';

export default class OverworldStateMachine {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);

        const availableMapsForSerialization = {};
        Object.entries(this.availableMaps).forEach(([mapId, map]) => {
            availableMapsForSerialization[mapId] = map.serialize();
        });
        return {
            // Core references
            player: this.player.serialize({ options: this.optionsMenu.serialize() }),
            currentMap: this.currentMap.serialize(),
            availableMaps: availableMapsForSerialization,
            currentLocation: this.currentLocation,

            // Movement and state
            movementSpeed: this.movementSpeed,
            currentState: IDLE,
            previousState: IDLE,
            stateHistory: this.stateHistory,

            // UI and text state
            overworldText: '',
            cursor: 0,

            // Menu states
            martMenuOption: this.martMenuOption,
            pokemonOption: this.pokemonOption,
            pokedexMenuOption: this.pokedexMenuOption,
            pokemonDetailOption: this.pokemonDetailOption,
            summaryOption: this.summaryOption,
            moveDetailOption: this.moveDetailOption,
            bagItemDetailOption: this.bagItemDetailOption,
            martItemOption: this.martItemOption,
            martItemAmount: this.martItemAmount,

            // Yes/No dialog state
            isAskingYesOrNo: this.isAskingYesOrNo,
            yesOrNoOption: this.yesOrNoOption,

            // PC Menu state (strip live Pokemon references — they hold HTMLImageElements)
            pcMenu: {
                ...this.pcMenu,
                partyList: [null, null, null, null, null, null],
                currentPokemon: null,
                selectedPokemon: null,
                swapBufferPokemon: null,
            },

            // Flags and settings
            shouldCancel: this.shouldCancel,
            isTransitioning: this.isTransitioning,
            interactionBuffer: this.interactionBuffer,

            // Context data
            context: null,

            // Current mart inventory
            currentMartInventory: this.currentMartInventory,

            // Current summary pokemon reference
            currentSummaryPokemon: null,

            // Collision state
            collisions: this.collisions,

            totalTimePlayed: this.totalTimePlayed,

            // Adjacent objects - these are runtime references, will be rebuilt
            // Don't serialize adjacentObjects as they're rebuilt during gameplay

            // Don't serialize: actions, stateQueue, battleStateMachine (runtime state)
        };
    }

    static async deserialize(data) {
        // Deserialize player and map
        const player = await Player.deserialize(data.player);
        const currentMap = await GameMap.deserialize(data.currentMap);

        // Create OSM with core dependencies
        const osm = new OverworldStateMachine({
            player: player,
            map: currentMap,
        });

        if (player._savedOptions) {
            osm.optionsMenu.applySerialized(player._savedOptions);
            delete player._savedOptions;
        }

        // Restore all state
        const mapEntries = Object.entries(data.availableMaps ?? {});
        const deserializedMaps = await Promise.all(mapEntries.map(([, map]) => GameMap.deserialize(map)));

        deserializedMaps.forEach((deserializedMap, index) => {
            const [mapId] = mapEntries[index];
            osm.availableMaps[mapId] = deserializedMap;
        });

        if (osm.availableMaps[osm.currentMap.identifer] === undefined) {
            osm.availableMaps[osm.currentMap.identifier] = osm.currentMap;
        }

        osm.movementSpeed = data.movementSpeed;
        osm.currentState = data.currentState;
        osm.previousState = data.previousState;
        osm.stateHistory = data.stateHistory ?? [IDLE];
        osm.overworldText = data.overworldText;
        osm.cursor = data.cursor;
        osm.currentLocation = Location.get(data.currentLocation.locationId);

        // Restore menu states
        osm.martMenuOption = data.martMenuOption;
        osm.pokemonOption = data.pokemonOption;
        osm.pokedexMenuOption = data.pokedexMenuOption;
        osm.pokemonDetailOption = data.pokemonDetailOption;
        osm.summaryOption = data.summaryOption;
        osm.moveDetailOption = data.moveDetailOption;
        osm.bagOption = data.bagOption;
        osm.bagItemDetailOption = data.bagItemDetailOption;
        osm.martItemOption = data.martItemOption;
        osm.martItemAmount = data.martItemAmount;

        // Restore dialog state
        osm.isAskingYesOrNo = data.isAskingYesOrNo;
        osm.yesOrNoOption = data.yesOrNoOption;

        // Restore PC menu state
        osm.pcMenu = data.pcMenu;

        // Restore flags
        osm.shouldCancel = data.shouldCancel;
        osm.isTransitioning = data.isTransitioning;
        osm.interactionBuffer = data.interactionBuffer;

        // Restore context
        osm.context = data.context || {};

        // Restore mart state
        osm.currentMartInventory = data.currentMartInventory || [];

        // Restore current summary pokemon if it exists
        if (data.currentSummaryPokemon) {
            osm.currentSummaryPokemon = await Pokemon.deserialize(data.currentSummaryPokemon);
        }

        // Restore collision state
        osm.collisions = data.collisions;

        osm.totalTimePlayed = data.totalTimePlayed || 0;

        // Note: adjacentObjects, actions, stateQueue, battleStateMachine will be rebuilt during gameplay

        return osm;
    }

    constructor({ player, map }) {
        this.player = player;
        this.movementSpeed = 0.5;
        this.currentState = INTRO_CREDITS;
        this.previousState = IDLE;
        this.stateHistory = [];
        this.overworldText = '';
        this.overworldTextSpeaker = '';
        this.cursor = 0;
        this.actions = [];
        // const testStateQueue = [IDLE];
        const prodStateQueue = [INTRO_CREDITS];
        this.stateQueue = prodStateQueue;
        this.collisions = {
            up: false,
            left: false,
            down: false,
            right: false,
        };
        this.adjacentObjects = {
            up: null,
            left: null,
            down: null,
            right: null,
        };
        this.pcMenu = {
            currentSection: 0,
            box: 0,
            row: 0,
            column: 0,
            partyList: [null, null, null, null, null, null],
            currentPokemon: null, // Pokemon you're hovering over
            selectedPokemon: null, // Pokemon you actually grabbed
            swapBufferPokemon: null,
            selectedPokemonOriginalPosition: {
                box: null,
                column: null,
                row: null,
                section: null,
            },
            preselectionOptions: ['Move', 'Summary', 'Release'],
            preselectionOption: 0,
        };
        this.shouldCancel = false;
        this.martMenuOption = 0;
        this.pokemonOption = 0;
        this.pokedexMenuOption = 0;
        this.pokemonDetailOption = 0;
        this.summaryOption = 0;
        this.moveDetailOption = 0;
        this.bagItemDetailOption = 0;
        this.martItemOption = 0;
        this.isAskingYesOrNo = false;
        this.yesOrNoOption = 0;
        this.context = {};
        this.gridAlignmentHistory = [true, true];
        this.justBattled = false;
        this.trainerBattleHistory = []; // Most recent battle first

        this.currentMap = map;
        this.isTransitioning = false;
        this.battleStateMachine = {};
        this.interactionBuffer = 0;
        this.currentMartInventory = [];
        this.martItemAmount = 1;
        // Cheats
        this.skipEvents = false;

        this.currentSummaryPokemon = null;
        this.performance = 0;
        this.performanceSnapshot = 0;
        // Spawn Location. The player physically starts inside player_house,
        // but the logical "current location" tracks the town they are in so
        // features like the town map work from the very first frame.
        this.currentLocation = Location.get('bramblecrest');
        this.playerGenderMenu = new PlayerGenderMenu();
        this.keyboardMenu = new KeyboardMenu({});
        this.pauseMenu = new PauseMenu({});
        this.optionsMenu = new OptionsMenu({});
        this.bagMenu = new BagMenuBackEnd({});
        this.menuHandler = new MenuHandler({});
        this.saveFileMenu = new SaveFileMenu({});
        this.yesOrNoMenu = new YesOrNoMenu();
        this.activeNPC = null;
        this.availableMaps = {};
        this.userInputWithinLastMinute = false;
        this.totalTimePlayed = 0;

        // Auto-save tracking
        this.lastAutoSaveTime = Date.now();
        this.autoSaveInterval = 5000; // 5 seconds in milliseconds
        this.isAutoSaving = false; // Prevent multiple simultaneous saves
        this.lastPlayerActivityTime = Date.now(); // Track when player last moved/interacted
        this.idleTimeForAutoSave = 500; // Require 0.5 seconds of idle time before auto-save
    }

    /**
     * Helper method to check if walk through walls cheat is enabled.
     * Safely handles cases where optionsMenu might not be initialized yet.
     * @returns {boolean} True if the cheat is enabled, false otherwise
     */
    canWalkThroughWalls() {
        return this.optionsMenu?.overworldCheatWalkThroughWalls === 'on';
    }

    /**
     * Helper method to check if skip wild battles cheat is enabled.
     * Safely handles cases where optionsMenu might not be initialized yet.
     * @returns {boolean} True if the cheat is enabled, false otherwise
     */
    shouldSkipWildBattles() {
        return this.optionsMenu?.overworldCheatSkipWildBattles === 'on';
    }

    /**
     * Helper method to check if skip trainer battles cheat is enabled.
     * Safely handles cases where optionsMenu might not be initialized yet.
     * @returns {boolean} True if the cheat is enabled, false otherwise
     */
    shouldSkipTrainerBattles() {
        return this.optionsMenu?.overworldCheatSkipTrainerBattles === 'on';
    }

    /**
     * Helper method to check if skip overworld events cheat is enabled.
     * Safely handles cases where optionsMenu might not be initialized yet.
     * @returns {boolean} True if the cheat is enabled, false otherwise
     */
    shouldSkipOverworldEvents() {
        return this.optionsMenu?.overworldCheatSkipOverworldEvents === 'on';
    }

    /**
     * Get the text speed multiplier based on options menu setting.
     * Returns the number of frames to wait before incrementing cursor (for overworld)
     * or the increment amount per frame (for battle).
     * @returns {number} Buffer value for overworld (higher = slower), or increment for battle (higher = faster)
     */
    getTextSpeedBuffer() {
        const textSpeed = this.optionsMenu?.textSpeed ?? 'medium';
        switch (textSpeed) {
            case 'slow':
                return 4; // Slow: 1 character every 4 frames
            case 'medium':
                return 1; // Medium: 1 character every frame
            case 'fast':
                return 1; // Fast: 2 characters per update (handled separately in increment logic)
            case 'super fast':
                return 1; // Super Fast: 4 characters per update (handled separately in increment logic)
            default:
                return 1; // Default to medium
        }
    }

    /**
     * Get the cursor increment amount per update (for fast speed)
     * @returns {number} Number of characters to advance per update
     */
    getTextSpeedIncrementAmount() {
        const textSpeed = this.optionsMenu?.textSpeed ?? 'medium';
        switch (textSpeed) {
            case 'slow':
            case 'medium':
                return 1; // Normal: 1 character per update
            case 'fast':
                return 2; // Fast: 2 characters per update (twice as fast as medium)
            case 'super fast':
                return 4; // Super Fast: 4 characters per update (twice as fast as fast)
            default:
                return 1;
        }
    }

    /**
     * Get the text speed increment for battle text cursor.
     * @returns {number} Increment amount per frame (higher = faster)
     */
    getTextSpeedIncrement() {
        const textSpeed = this.optionsMenu?.textSpeed ?? 'medium';
        switch (textSpeed) {
            case 'slow':
                return 0.25; // Slow: 0.25 characters per frame
            case 'medium':
                return 1; // Medium: 1 character per frame
            case 'fast':
                return 2; // Fast: 2 characters per frame (twice as fast as medium)
            case 'super fast':
                return 4; // Super Fast: 4 characters per frame (twice as fast as fast)
            default:
                return 1; // Default to medium
        }
    }

    /**
     * Whether the overworld is currently in the BATTLE state (battle animation loop should run).
     * @returns {boolean}
     */
    isInBattle() {
        return this.currentState === BATTLE;
    }

    static loadMap = async ({
        identifier,
        source,
        availablePokemon,
        mapDimensions,
        backgroundSrc,
        foregroundSrc,
        backgroundSources,
        foregroundSources,
        mapType = 'route',
        needsFlash = false,
        canBike = true,
        fixedTimeOfDay: fixedTimeOfDayParam = null,
    }) => {
        try {
            const response = await fetch(source);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            const mapProperties = data?.properties ?? [];
            // Use passed fixedTimeOfDay if provided, otherwise fall back to TMJ file property
            const fixedTimeOfDay =
                fixedTimeOfDayParam ??
                mapProperties.find((property) => property.name === 'fixedTimeOfDay')?.value;

            const boundaries = [];
            const battleZones = [];
            const waterZones = [];
            const pcLocations = [];
            const waterEntryZones = [];
            const landEntryZones = [];
            const downLedges = [];
            const leftLedges = [];
            const rightLedges = [];
            const npcs = [];
            const trainers = [];
            const textSources = [];
            const warpZones = [];
            const locationIndicatorZones = [];
            const overworldItems = [];
            const hmTrees = [];
            const hmRocks = [];
            const healingLocations = [];
            const martLocations = [];
            const verticalPositionControls = [];
            const diagonalMovementControls = [];
            const flowers = [];
            const eventTriggers = [];
            const teleportLocations = [];
            const staticEncounters = [];
            const starterPokemonPokeballs = [];

            // Utility function to process 1D array data
            const processLayer = (layerData, ClassType, targetArray, zIndex, options = {}) => {
                const { width } = mapDimensions;
                // console.log(layerData);
                layerData.forEach((tile, index) => {
                    if (tile !== 0) {
                        const i = Math.floor(index / width); // Calculate row
                        const j = index % width; // Calculate column

                        targetArray.push(
                            new ClassType({
                                position: {
                                    x: j * Boundary.width, // Column -> X-coordinate
                                    y: i * Boundary.height, // Row -> Y-coordinate
                                    z: zIndex,
                                },
                                data: tile, // Pass additional data if needed
                                ...options,
                            })
                        );
                    }
                });
            };

            const processNPCLayer = (layerData, targetArray, zIndex) => {
                const npcs = layerData.objects;
                npcs.forEach((npc) => {
                    const npcPropertiesText1 = npc.properties.find(
                        (npcProperties) => npcProperties.name === 'text1'
                    );
                    const npcPropertiesType = npc.properties.find(
                        (npcProperties) => npcProperties.name === 'type'
                    );
                    const npcPropertiesDirection = npc.properties.find(
                        (npcProperties) => npcProperties.name === 'direction'
                    );
                    const npcPropertiesMovementPattern = npc.properties.find(
                        (npcProperties) => npcProperties.name === 'movementPattern'
                    );
                    const npcPropertiesIdentifierLayer = npc.properties.find(
                        (npcProperties) => npcProperties.name === 'identifier'
                    );
                    if (npcPropertiesText1 === null) {
                        console.warn('NPC has no text1 value.', npc);
                    } else if (npcPropertiesType === null) {
                        console.warn('NPC has no type value.', npc);
                    } else {
                        const newNPC = new NPC({
                            text: npcPropertiesText1.value,
                            position: {
                                x: npc.x,
                                y: npc.y - 16,
                                z: zIndex,
                            },
                            type: npcPropertiesType.value,
                            direction: npcPropertiesDirection?.value ?? 'down',
                            movementPattern: npcPropertiesMovementPattern?.value ?? 'idle',
                            name: npc.name ?? '',
                            identifier: npcPropertiesIdentifierLayer?.value ?? null,
                        });
                        targetArray.push(newNPC);
                    }
                });
            };

            const findProperty = (dataObject, targetProperty) => {
                if (!dataObject.properties) {
                    console.warn(`Property ${targetProperty} not set on object.`);
                    console.warn(`Map: ${identifier}`);
                    console.warn(`Object: ${dataObject.name}`);
                    return null;
                }
                const propertyObject = dataObject.properties.find((p) => p.name === targetProperty) || null;
                if (propertyObject === null) {
                    console.warn(`Property '${targetProperty}' unavailable: `, dataObject);
                    return null;
                }
                return propertyObject.value;
            };

            const processTrainerLayer = (layerData, targetArray, zIndex) => {
                const trainers = layerData.objects;
                trainers.forEach((trainer) => {
                    const identifier = findProperty(trainer, 'identifier') || 'fallback_trainer';
                    const direction = findProperty(trainer, 'direction') || 'down';
                    const viewRange = findProperty(trainer, 'viewRange') || 1;
                    const currentTrainerData = trainerData[identifier];
                    if (currentTrainerData === null) {
                        console.warn('No trainer available for identifier ', identifier);
                    } else {
                        const newTrainer = new Trainer({
                            name: currentTrainerData.name,
                            identifier: identifier,
                            position: {
                                x: trainer.x,
                                y: trainer.y - 16,
                                z: zIndex,
                            },
                            direction: direction,
                            type: currentTrainerData.type,
                            isDefeated: currentTrainerData.isDefeated,
                            viewRange: parseInt(viewRange),
                            preBattleText: currentTrainerData.preBattleText,
                            postBattleText: currentTrainerData.postBattleText,
                            text: currentTrainerData.text,
                            movementPattern: currentTrainerData.movementPattern,
                            party: currentTrainerData.party.map((pokemonData) => {
                                const newPokemon = new Pokemon({
                                    id: pokemonData.id,
                                    level: pokemonData.level,
                                });
                                newPokemon.moves = newPokemon.getMoves(pokemonData.moves);
                                return newPokemon;
                            }),
                        });
                        targetArray.push(newTrainer);
                    }
                });
            };

            const processOverworldItemLayer = (layerData, targetArray, zIndex) => {
                const items = layerData.objects;
                items.forEach((item) => {
                    const overworldItemIdentifierLayer = findProperty(item, 'identifier');
                    const newItem = new OverworldItem({
                        identifier: overworldItemIdentifierLayer,
                        item: ItemFactory.create(item.name),
                        position: {
                            x: item.x,
                            y: item.y - 16,
                            z: zIndex,
                        },
                        acquired: false,
                        visible: true,
                    });
                    targetArray.push(newItem);
                });
            };

            const processTextSourceLayer = (layerData, targetArray, zIndex) => {
                const textSources = layerData.objects;
                textSources.forEach((textSource) => {
                    const text1Object = textSource.properties.find((tsp) => tsp.name === 'text0');
                    if (text1Object === null || text1Object === undefined) {
                        console.warn('Text source has no text1 value.');
                    } else {
                        const text1 = text1Object.value;
                        const newTextSource = new TextSource({
                            text: text1,
                            position: {
                                x: textSource.x,
                                y: textSource.y - 16,
                                z: zIndex,
                            },
                        });
                        targetArray.push(newTextSource);
                    }
                });
            };

            const processHealingLocationLayer = (layerData, targetArray, zIndex) => {
                const healingLocations = layerData.objects;
                healingLocations.forEach((healingLocation) => {
                    const preInteractionText = findProperty(healingLocation, 'preInteractionText');
                    const postInteractionText = findProperty(healingLocation, 'postInteractionText');
                    const newHealingLocation = new HealingLocation({
                        preInteractionText: preInteractionText,
                        postInteractionText: postInteractionText,
                        position: {
                            x: healingLocation.x,
                            y: healingLocation.y - 16,
                            z: zIndex,
                        },
                    });
                    targetArray.push(newHealingLocation);
                });
            };

            const processMartLocationLayer = (layerData, targetArray, zIndex) => {
                const martLocations = layerData.objects;
                martLocations.forEach((martLocation) => {
                    const identifier = findProperty(martLocation, 'identifier');
                    const newMartLocation = new MartLocation({
                        OSM: this,
                        identifier: identifier,
                        position: {
                            x: martLocation.x,
                            y: martLocation.y - 16,
                            z: zIndex,
                        },
                    });
                    targetArray.push(newMartLocation);
                });
            };

            const processWarpZoneLayer = (layerData, targetArray, zIndex) => {
                const warpZones = layerData.objects;
                warpZones.forEach((warpZone) => {
                    const destinationWarpZone = findProperty(warpZone, 'destinationWarpZone');
                    const destinationMap = findProperty(warpZone, 'destinationMap');
                    const identifier = findProperty(warpZone, 'identifier');
                    const destinationXOffset = findProperty(warpZone, 'destinationXOffset');
                    const destinationYOffset = findProperty(warpZone, 'destinationYOffset');
                    const destinationDirection = findProperty(warpZone, 'destinationDirection');
                    const newWarpZone = new WarpZone({
                        destinationWarpZone: destinationWarpZone,
                        destinationMap: destinationMap,
                        position: {
                            x: warpZone.x,
                            y: warpZone.y - 16,
                            z: zIndex,
                        },
                        identifier: identifier,
                        destinationXOffset: destinationXOffset,
                        destinationYOffset: destinationYOffset,
                        destinationDirection: destinationDirection,
                    });
                    targetArray.push(newWarpZone);
                });
            };

            const processEventTriggerLayer = (layerData, targetArray, zIndex) => {
                const eventTriggers = layerData.objects;
                eventTriggers.forEach((trigger) => {
                    const eventIdentifier = findProperty(trigger, 'eventIdentifier');
                    const eventTriggerIdentifier = findProperty(trigger, 'identifier');
                    const eventTriggerType = findProperty(trigger, 'type');
                    const newEventTrigger = new EventTrigger({
                        eventIdentifier: eventIdentifier,
                        identifier: eventTriggerIdentifier,
                        position: {
                            x: trigger.x,
                            y: trigger.y - 16,
                            z: zIndex,
                        },
                    });
                    if (eventTriggerType === null) {
                        newEventTrigger.type = ETT_ON_ENTER;
                    } else {
                        newEventTrigger.type = eventTriggerType;
                    }
                    targetArray.push(newEventTrigger);
                });
            };

            const processTeleportLocationLayer = (layerData, targetArray, zIndex) => {
                const teleportLocations = layerData.objects;
                teleportLocations.forEach((teleportLocation) => {
                    targetArray.push(
                        new TeleportLocation({
                            identifier: findProperty(teleportLocation, 'identifier'),
                            position: {
                                x: teleportLocation.x,
                                y: teleportLocation.y - 16,
                                z: zIndex,
                            },
                            xOffset: parseInt(findProperty(teleportLocation, 'xOffset')) || 0,
                            yOffset: parseInt(findProperty(teleportLocation, 'yOffset')) || 0,
                        })
                    );
                });
            };

            const processLocationIndicatorZoneLayer = (layerData, targetArray, zIndex) => {
                const locationIndicatorZones = layerData.objects;
                locationIndicatorZones.forEach((liz) => {
                    const locationId = findProperty(liz, 'locationId');
                    const newLocationIndicatorZone = new LocationIndicatorZone({
                        locationId: locationId,
                        position: {
                            x: liz.x,
                            y: liz.y - 16,
                            z: zIndex,
                        },
                    });
                    targetArray.push(newLocationIndicatorZone);
                });
            };

            const processDiagonalMovementControlLayer = (layerData, targetArray, zIndex) => {
                layerData.forEach((dmcLayerData) => {
                    if (dmcLayerData) {
                        dmcLayerData.objects.forEach((dmcObject) => {
                            const newDiagonalMovementControl = new DiagonalMovementControl({
                                position: {
                                    x: dmcObject.x,
                                    y: dmcObject.y - 16,
                                    z: zIndex,
                                },
                                direction: dmcLayerData.name,
                            });
                            targetArray.push(newDiagonalMovementControl);
                        });
                    }
                });
            };

            const processStarterPokemonPokeballLayer = (layerData, targetArray, zIndex) => {
                const starterPokemonPokeballObjects = layerData.objects;
                starterPokemonPokeballObjects.forEach((starterPokemonPokeball) => {
                    const identifier = findProperty(starterPokemonPokeball, 'identifier');
                    const pokemonId = findProperty(starterPokemonPokeball, 'pokemonId');
                    const level = parseInt(findProperty(starterPokemonPokeball, 'level')) || 5;
                    const id = parseInt(findProperty(starterPokemonPokeball, 'id'));
                    const newStarterPokemonPokeball = new StarterPokemonPokeball({
                        position: {
                            x: starterPokemonPokeball.x,
                            y: starterPokemonPokeball.y - 16,
                            z: zIndex,
                        },
                        identifier: identifier,
                        pokemonId: pokemonId,
                        level: level,
                        id: id,
                    });
                    newStarterPokemonPokeball.createPokemon();
                    targetArray.push(newStarterPokemonPokeball);
                });
            };

            const processStaticEncounterLayer = (layerData, targetArray, zIndex) => {
                const staticEncounterObjects = layerData.objects;
                staticEncounterObjects.forEach((staticEncounter) => {
                    const level = parseInt(findProperty(staticEncounter, 'level')) || 5;
                    const id = parseInt(findProperty(staticEncounter, 'id'));
                    const pokemonId = findProperty(staticEncounter, 'pokemonId');
                    const identifier = findProperty(staticEncounter, 'identifier');

                    if (pokemonId === null) {
                        console.warn('Static encounter has no pokemonId value.', staticEncounter);
                        return;
                    }
                    const newStaticEncounter = new StaticEncounter({
                        position: {
                            x: staticEncounter.x,
                            y: staticEncounter.y - 16,
                            z: zIndex,
                        },
                        id: id,
                        level: level,
                        pokemonId: pokemonId,
                        identifier: identifier,
                    });
                    targetArray.push(newStaticEncounter);
                });
            };

            const processVerticalPositionControlLayer = (layerData, targetArray, zIndex) => {
                layerData.forEach((vpcLayerData) => {
                    if (vpcLayerData.objects) {
                        vpcLayerData.objects.forEach((vpcObject) => {
                            const newVerticalPositionControl = new VerticalPositionControl({
                                position: {
                                    x: vpcObject.x,
                                    y: vpcObject.y - 16, // Tiled is rendering these out with a 16px offset downward.
                                    z: zIndex,
                                },
                            });
                            if (vpcLayerData.name === 'vpc_down') {
                                newVerticalPositionControl.nextZ = zIndex - 1;
                            }
                            if (vpcLayerData.name === 'vpc_up') {
                                newVerticalPositionControl.nextZ = zIndex + 1;
                            }
                            targetArray.push(newVerticalPositionControl);
                        });
                    }
                });
            };

            data.layers.forEach((dataLayer) => {
                const zIndex = parseInt(dataLayer.name.slice(-1));
                dataLayer.layers.forEach((layer) => {
                    switch (layer.name) {
                        case 'text_sources':
                            // processLayer(layer.data, TextSource, textSources);
                            processTextSourceLayer(layer, textSources, zIndex);
                            break;
                        case 'water_zones':
                            processLayer(layer.data, BattleZone, battleZones, zIndex, {
                                visible: false,
                                encounterType: 'water',
                            });
                            break;
                        case 'battle_zones': {
                            const options = {
                                visible: true,
                            };
                            if (mapType === 'cave') {
                                options.visible = false;
                            }
                            processLayer(layer.data, BattleZone, battleZones, zIndex, options);
                            break;
                        }

                        case 'hm_trees':
                            processLayer(layer.data, HMTree, hmTrees, zIndex);
                            break;

                        case 'hm_rocks':
                            processLayer(layer.data, HMRock, hmRocks, zIndex);
                            break;

                        case 'ledge_up':
                            processLayer(layer.data, Boundary, boundaries, zIndex);
                            break;

                        case 'ledge_left':
                            processLayer(layer.data, LeftLedge, leftLedges, zIndex);
                            break;

                        case 'ledge_right':
                            processLayer(layer.data, RightLedge, rightLedges, zIndex);
                            break;

                        case 'ledge_down':
                            processLayer(layer.data, DownLedge, downLedges, zIndex);
                            break;

                        case 'npcs':
                            processNPCLayer(layer, npcs, zIndex);
                            break;

                        case 'trainers':
                            processTrainerLayer(layer, trainers, zIndex);
                            break;

                        case 'collisions':
                            // Always process collisions during map loading (cheat only affects runtime behavior)
                            processLayer(layer.data, Boundary, boundaries, zIndex);
                            break;
                        case 'overworld_items':
                            processOverworldItemLayer(layer, overworldItems, zIndex);
                            break;
                        case 'water_entry':
                            processLayer(layer.data, WaterEntryZone, waterEntryZones, zIndex);
                            break;

                        case 'land_entry':
                            processLayer(layer.data, LandEntryZone, landEntryZones, zIndex);
                            break;

                        case 'foreground':
                            // Nothing to process here.
                            break;

                        case 'background':
                            // Nothing to process here.
                            break;

                        case 'terrain':
                            // Nothing to process here.
                            break;

                        case 'buildings':
                            // Nothing to process here.
                            break;

                        case 'warp_zones':
                            processWarpZoneLayer(layer, warpZones, zIndex);
                            break;

                        case 'location_indicator_zones':
                            processLocationIndicatorZoneLayer(layer, locationIndicatorZones, zIndex);
                            break;

                        case 'healing_sources':
                            processHealingLocationLayer(layer, healingLocations, zIndex);
                            break;

                        case 'pc_locations':
                            processLayer(layer.data, PCLocation, pcLocations, zIndex);
                            break;
                        case 'mart_sources':
                            processMartLocationLayer(layer, martLocations, zIndex);
                            break;

                        case 'vertical_position_controls':
                            processVerticalPositionControlLayer(
                                layer.layers,
                                verticalPositionControls,
                                parseInt(dataLayer.name.slice(-1))
                            );
                            break;

                        case 'diagonal_movement_controls':
                            processDiagonalMovementControlLayer(
                                layer.layers,
                                diagonalMovementControls,
                                parseInt(dataLayer.name.slice(-1))
                            );
                            break;

                        case 'flowers':
                            processLayer(layer.data, OverworldDecoration, flowers, zIndex, {
                                type: 'flowers',
                            });
                            break;
                        case 'event_triggers':
                            processEventTriggerLayer(layer, eventTriggers, zIndex);
                            break;

                        case 'teleport_locations':
                            processTeleportLocationLayer(layer, teleportLocations, zIndex);
                            break;

                        case 'static_encounters':
                            processStaticEncounterLayer(layer, staticEncounters, zIndex);
                            break;

                        case 'starter_pokemon_pokeballs':
                            processStarterPokemonPokeballLayer(layer, starterPokemonPokeballs, zIndex);
                            break;

                        default:
                            console.warn(`Unknown layer name: ${layer.name} in ${source}`);
                            break;
                    }
                });
            });

            const newGameMap = new GameMap({
                identifier,
                boundaries,
                battleZones,
                downLedges,
                waterZones,
                pcLocations,
                waterEntryZones,
                landEntryZones,
                leftLedges,
                rightLedges,
                npcs,
                textSources,
                warpZones,
                eventTriggers,
                teleportLocations,
                locationIndicatorZones,
                verticalPositionControls,
                diagonalMovementControls,
                healingLocations,
                martLocations,
                overworldItems,
                hmTrees,
                hmRocks,
                trainers,
                staticEncounters,
                starterPokemonPokeballs,
                availablePokemon,
                backgroundSrc,
                foregroundSrc,
                backgroundSources,
                foregroundSources,
                flowers,
                needsFlash,
                canBike,
                fixedTimeOfDay,
            });
            // Load events from event trigger data:
            // Get unique event identifiers to avoid loading duplicate events
            const uniqueEventIdentifiers = [...new Set(eventTriggers.map((et) => et.eventIdentifier))];
            const events = await Promise.all(
                uniqueEventIdentifiers.map(async (eventIdentifier) => {
                    const event = await BaseEvent.loadEvent(eventIdentifier);
                    event.map = newGameMap;
                    return event;
                })
            );
            newGameMap.events = events;
            newGameMap.events.forEach((event) => {
                event.loadObjects();
            });
            return newGameMap;
        } catch (error) {
            console.error('Error loading JSON:', error);
        }
    };

    updateGridAlignmentHistory() {
        if (this.alignedToGrid()) {
            this.gridAlignmentHistory.unshift(true);
        } else {
            this.gridAlignmentHistory.unshift(false);
        }
        this.gridAlignmentHistory.pop();
    }

    arrivedInGridCell() {
        // This method defines the transient moment when the player arrives in the grid cell
        return this.gridAlignmentHistory[0] === true && this.gridAlignmentHistory[1] === false;
    }

    leftGridCell() {
        // This method defines the transient moment when the player leaves the grid cell
        return this.gridAlignmentHistory[0] === false && this.gridAlignmentHistory[1] === true;
    }

    updateCollisions() {
        // Reset collision state
        this.collisions = { up: false, down: false, left: false, right: false };
        this.adjacentObjects = { up: null, down: null, left: null, right: null, center: null };

        const playerZ = this.player.position.z;
        const playerX = this.player.position.x;
        const playerY = this.player.position.y;

        // Pre-calculate collision positions once
        const checkPositions = {
            up: { x: playerX, y: playerY - 16 },
            down: { x: playerX, y: playerY + 16 },
            left: { x: playerX - 16, y: playerY },
            right: { x: playerX + 16, y: playerY },
            center: { x: playerX, y: playerY },
        };

        // Collect all objects that can be collided with or adjacent to
        const allObjects = [
            ...this.currentMap.boundaries,
            ...this.currentMap.textSources,
            ...this.currentMap.battleZones,
            ...this.currentMap.waterZones,
            ...this.currentMap.pcLocations,
            ...this.currentMap.waterEntryZones,
            ...this.currentMap.landEntryZones,
            ...this.currentMap.downLedges,
            ...this.currentMap.leftLedges,
            ...this.currentMap.rightLedges,
            ...this.currentMap.npcs,
            ...this.currentMap.trainers,
            ...this.currentMap.overworldItems,
            ...this.currentMap.hmTrees,
            ...this.currentMap.hmRocks,
            ...this.currentMap.warpZones,
            ...this.currentMap.locationIndicatorZones,
            ...this.currentMap.eventTriggers,
            ...this.currentMap.teleportLocations,
            ...this.currentMap.verticalPositionControls,
            ...this.currentMap.diagonalMovementControls,
            ...this.currentMap.flowers,
            ...this.currentMap.healingLocations,
            ...this.currentMap.martLocations,
            ...this.currentMap.staticEncounters,
        ];

        // Single pass through all objects
        for (const obj of allObjects) {
            // Skip if not on same plane
            if (obj.position.z !== playerZ) continue;

            const objX = obj.position.x;
            const objY = obj.position.y;

            // Check each direction efficiently
            for (const [direction, pos] of Object.entries(checkPositions)) {
                if (objX === pos.x && objY === pos.y) {
                    // Set adjacency for all directions

                    // This block ensures that if, for example an NPC is in the same exact
                    // location as another object, the adjacentObjects map is updated with
                    // the NPC so it is interactable.
                    // TODO: The adjacency map should probably be a list of objects sorted by priority.
                    const existingObj = this.adjacentObjects[direction];
                    if (existingObj === null || existingObj === undefined) {
                        // No existing object, assign this one
                        this.adjacentObjects[direction] = obj;
                    } else {
                        // Compare priorities (default to 0 if undefined/null)
                        const existingPriority = existingObj.interactionPriority ?? 0;
                        const newPriority = obj.interactionPriority ?? 0;
                        if (newPriority > existingPriority) {
                            this.adjacentObjects[direction] = obj;
                        }
                    }

                    // Handle collisions (except for center)
                    if (
                        direction !== 'center' &&
                        this.shouldCollideWith(obj) &&
                        !this.canWalkThroughWalls()
                    ) {
                        this.collisions[direction] = true;
                    }

                    // Special ledge collision logic
                    if (direction !== 'center') {
                        this.handleLedgeCollisions(obj, direction);
                    }

                    break; // Object found for this position, move to next object
                }
            }
        }
    }

    /**
     * Returns an OverworldAction that moves an NPC in a direction for N steps.
     * Does NOT push to this.actions — use with parallel()/series(), or call moveNPC() instead.
     * @param {NPC} npc
     * @param {string} direction - UP, DOWN, LEFT, RIGHT
     * @param {number} steps
     * @returns {OverworldAction}
     */
    createMoveNPCAction(npc, direction, steps) {
        return new OverworldAction({
            startAction: () => {
                npc.direction = direction;
                npc.stateMachine.context.requiredSteps = steps;
                npc.stateMachine.stateQueue.push(MOVE_N_STEPS);
                npc.stateMachine.stateQueue.push(END_MOVING);
            },
            action: () => {
                return npc.stateMachine.stateQueue.length === 0;
            },
        });
    }

    /**
     * Pushes an NPC directional movement action to the queue.
     * @param {NPC} npc
     * @param {string} direction - UP, DOWN, LEFT, RIGHT
     * @param {number} steps
     */
    moveNPC(npc, direction, steps) {
        this.actions.push(this.createMoveNPCAction(npc, direction, steps));
    }

    /**
     * Returns an OverworldAction that moves an NPC to a target position via pathfinding.
     * Does NOT push to this.actions — use with parallel()/series(), or call moveNPCV2() instead.
     * @param {NPC} npc
     * @param {Object} toPosition - {x, y, z}
     * @param {Object} [options]
     * @param {string} [options.facingDirection] - Direction the NPC faces after arriving (LEFT/RIGHT/UP/DOWN)
     * @param {boolean} [options.skipCollisions] - If true, pathfinding ignores all collisions and finds the shortest path
     * @returns {OverworldAction}
     */
    createMoveNPCV2Action(npc, toPosition, options = {}) {
        return new OverworldAction({
            startAction: () => {
                npc.stateMachine.context.targetPosition = toPosition;

                try {
                    const movements = this.calculateMovementsForPosition({
                        object: npc,
                        fromPosition: npc.position,
                        toPosition: toPosition,
                        skipCollisions: options.skipCollisions,
                    });

                    npc.stateMachine.context.movementSequence = movements.map((movement) => {
                        const direction = Object.keys(movement)[0];
                        const steps = movement[direction];
                        return { direction, steps };
                    });
                } catch (error) {
                    console.warn('Initial pathfinding failed, NPC will skip movement:', error);
                    npc.stateMachine.context.movementSequence = [];
                }
                npc.stateMachine.context.currentMovementIndex = 0;
                npc.stateMachine.context.previousForcedStepCount = 0;

                if (npc.stateMachine.context.movementSequence.length > 0) {
                    const firstMovement = npc.stateMachine.context.movementSequence[0];
                    npc.direction = firstMovement.direction;
                    npc.forcedStepCount = firstMovement.steps;
                    npc.stateMachine.context.previousForcedStepCount = firstMovement.steps;
                }

                npc.stateMachine.updateCollisions();
            },
            action: () => {
                npc.sprite.moving = true;
                npc.sprite.hold = 8;
                if (
                    npc.stateMachine.context.currentMovementIndex >=
                    npc.stateMachine.context.movementSequence.length
                ) {
                    return true;
                }

                if (npc.alignedToGrid()) {
                    try {
                        const movements = this.calculateMovementsForPosition({
                            object: npc,
                            fromPosition: npc.position,
                            toPosition: npc.stateMachine.context.targetPosition,
                            skipCollisions: options.skipCollisions,
                        });

                        npc.stateMachine.context.movementSequence = movements.map((movement) => {
                            const direction = Object.keys(movement)[0];
                            const steps = movement[direction];
                            return { direction, steps };
                        });

                        npc.stateMachine.context.currentMovementIndex = 0;

                        if (npc.stateMachine.context.movementSequence.length > 0) {
                            const firstMovement = npc.stateMachine.context.movementSequence[0];
                            npc.direction = firstMovement.direction;
                            npc.forcedStepCount = firstMovement.steps;
                            npc.stateMachine.context.previousForcedStepCount = firstMovement.steps;
                        } else {
                            npc.forcedStepCount = 0;
                            return true;
                        }
                    } catch (error) {
                        console.warn('Pathfinding failed:', error);
                        npc.forcedStepCount = 0;
                        return true;
                    }
                }

                if (npc.alignedToGrid()) {
                    if (
                        npc.forcedStepCount === 0 &&
                        npc.stateMachine.context.previousForcedStepCount > 0
                    ) {
                        npc.stateMachine.context.currentMovementIndex++;

                        if (
                            npc.stateMachine.context.currentMovementIndex <
                            npc.stateMachine.context.movementSequence.length
                        ) {
                            const nextMovement =
                                npc.stateMachine.context.movementSequence[
                                    npc.stateMachine.context.currentMovementIndex
                                ];
                            npc.direction = nextMovement.direction;
                            npc.forcedStepCount = nextMovement.steps;
                            npc.stateMachine.context.previousForcedStepCount = nextMovement.steps;
                        } else {
                            npc.forcedStepCount = 0;
                            return true;
                        }
                    }
                }

                if (npc.alignedToGrid()) {
                    npc.stateMachine.context.previousForcedStepCount = npc.currentForcedStepCount;
                }

                if (npc.alignedToGrid()) {
                    npc.step();

                    npc.stateMachine.updateCollisions();

                    if (!npc.stateMachine.canMove()) {
                        return false;
                    }
                }

                if (npc.stateMachine.canMove() && npc.forcedStepCount > 0) {
                    if (npc.direction === DOWN) {
                        npc.position.y += npc.movementSpeed;
                    } else if (npc.direction === LEFT) {
                        npc.position.x -= npc.movementSpeed;
                    } else if (npc.direction === RIGHT) {
                        npc.position.x += npc.movementSpeed;
                    } else if (npc.direction === UP) {
                        npc.position.y -= npc.movementSpeed;
                    }
                }

                return false;
            },
            endAction: () => {
                npc.sprite.moving = false;
                npc.sprite.frames.val = 0;
                npc.forcedStepCount = 0;
                npc.stateMachine.context.movementSequence = null;
                npc.stateMachine.context.currentMovementIndex = 0;
                npc.stateMachine.context.previousForcedStepCount = 0;
                npc.stateMachine.context.targetPosition = null;
                if (options.facingDirection) {
                    npc.direction = options.facingDirection;
                }
            },
        });
    }

    /**
     * Pushes an NPC pathfinding movement action to the queue.
     * @param {NPC} npc
     * @param {Object} toPosition - {x, y, z}
     * @param {Object} [options] - See createMoveNPCV2Action
     */
    moveNPCV2(npc, toPosition, options) {
        this.actions.push(this.createMoveNPCV2Action(npc, toPosition, options));
    }

    shouldCollideWith(obj) {
        // Get the constructor name or type identifier
        const objType = obj.constructor.name;

        switch (objType) {
            case 'Boundary':
                return true;

            case 'NPC':
            case 'Trainer':
                return true;

            case 'StaticEncounter':
                return true;

            case 'OverworldItem':
                return obj.visible && !obj.acquired;

            case 'WaterEntryZone':
                return !this.player.hasSurf();

            case 'HMTree':
                return obj.canInteract();

            case 'HMRock':
                return obj.canInteract();

            case 'DownLedge':
                return this.player.direction !== 'down';
            case 'LeftLedge':
                return this.player.direction !== 'left';
            case 'RightLedge':
                return this.player.direction !== 'right';

            // These objects are adjacent but don't cause collisions
            case 'TextSource':
            case 'BattleZone':
            case 'WaterZone':
            case 'PCLocation':
            case 'LandEntryZone':
            case 'WarpZone':
            case 'EventTrigger':
            case 'TeleportLocation':
            case 'LocationIndicatorZone':
            case 'VerticalPositionControl':
            case 'DiagonalMovementControl':
            case 'Flower':
            case 'HealingLocation':
            case 'MartLocation':
                return false;

            default:
                // Log unknown object types for debugging
                console.warn(`Unknown object type for collision: ${objType}`, obj);
                return false;
        }
    }

    handleLedgeCollisions(obj, direction) {
        // Handle special ledge collision rules from your original code
        const objType = obj.constructor.name;

        if (objType === 'DownLedge') {
            if (direction === 'up') {
                this.collisions.up = true;
            }
        }

        if (objType === 'LeftLedge') {
            if (direction === 'right') {
                this.collisions.right = true;
            }
        }

        if (objType === 'RightLedge') {
            if (direction === 'left') {
                this.collisions.left = true;
            }
        }
    }

    /**
     * Checks for zone interactions, triggers, and other shared logic between IDLE and MOVING states.
     * Returns true if an action was taken that should interrupt the current state.
     * @returns {boolean} True if an action was taken that should interrupt the current state
     */
    checkZoneInteractions() {
        // Check for trainer detection
        let seenByTrainer = false;
        this.currentMap.trainers.forEach((trainer) => {
            if (
                trainer.stateMachine.viewRangeMap.get(this.player.position.x, this.player.position.y) &&
                trainer.position.z === this.player.position.z
            ) {
                // Check for trainer battle (skip if cheat is enabled or trainer is already defeated)
                if (!trainer.isDefeated && !this.shouldSkipTrainerBattles()) {
                    this.context.npcSeenBy = trainer;
                    this.stateQueue.push(SEEN_BY_TRAINER);
                    seenByTrainer = true;
                }
            }
        });
        if (seenByTrainer) {
            console.log('seen by trainer');
            return true;
        }

        // Check location indicator zones
        this.currentMap.locationIndicatorZones.forEach((liz) => {
            if (liz.entered() && this.currentLocation.locationId !== liz.locationId) {
                this.enterLocation(liz.locationId);
            }
        });

        // Check teleport locations
        this.currentMap.teleportLocations.forEach((teleportLocation) => {
            if (teleportLocation.entered()) {
                console.log('Updated whiteout location.');
            }
        });

        // Check warp zones
        let enteredWarpZone = false;
        this.currentMap.warpZones.forEach((warpZone) => {
            if (warpZone.entered() && !warpZone.disabled) {
                this.stateQueue.push(WARP_TO_LOCATION);
                this.context.warpSource = warpZone.identifier;
                this.context.warpDestination = warpZone.destinationWarpZone;
                this.context.currentWarpZone = warpZone;
                enteredWarpZone = true;
            }
        });
        if (enteredWarpZone) {
            return true;
        }

        // Check vertical position controls
        this.currentMap.verticalPositionControls.forEach((vpc) => {
            if (vpc.entered()) {
                this.player.position.z = vpc.nextZ;
            }
        });

        // Check event triggers
        let eventTriggered = false;
        this.currentMap.eventTriggers.forEach((et) => {
            if (et.entered() && this.player.ignoreEventStepCount === 0) {
                const potentialEvent = this.currentMap.events.find(
                    (event) => event.identifier === et.eventIdentifier
                );
                if (!potentialEvent) {
                    console.warn(`No event found with identifier ${et.eventIdentifier}`);
                } else {
                    potentialEvent.preComplete();
                    if (potentialEvent.isActive && !potentialEvent.complete) {
                        this.context.currentEvent = potentialEvent;
                        this.stateQueue.push(OVERWORLD_EVENT);
                        eventTriggered = true;
                    }
                }
            }
        });
        if (eventTriggered) {
            return true;
        }

        // Check land/water entry zones
        const isEnteringLand =
            this.currentMap.landEntryZones.some((zone) => zone.entered()) && this.player.surfing;

        const isEnteringWater =
            this.currentMap.waterEntryZones.some((zone) => zone.entered()) && !this.player.surfing;

        if (isEnteringLand) {
            this.player.surfing = false;
        } else if (isEnteringWater) {
            this.player.surfing = true;
            this.player.biking = false;
        }

        return false;
    }

    update() {
        const p1 = performance.now();
        this.updateCollisions();
        this.updateGridAlignmentHistory();

        // Handle scroll continuation if text is waiting for user input
        if (this.overworldText && this.GUI && this.GUI.overworldText) {
            const overworldText = this.GUI.overworldText;
            if (overworldText.waitingForUserInput() && overworldText.canScroll) {
                if (KPI_L || KPI_K) {
                    // User pressed A button, continue scrolling
                    overworldText.requestScroll();
                }
            }
        }

        // If we are currently performing an action
        if (this.currentAction) {
            // But we actually just wrapped it up
            if (this.currentAction.ended) {
                // Grab the next action
                this.currentAction = this.actions.shift();
            } else {
                // Otherwise, we keep working on the current action
                // and fall back to the IDLE state if we run into
                // an issue.
                try {
                    // Check if it's a parallel wrapper
                    if (
                        this.currentAction &&
                        typeof this.currentAction === 'object' &&
                        this.currentAction._isParallel
                    ) {
                        // Execute parallel actions
                        this.currentAction.execute();
                        if (this.currentAction.ended) {
                            this.currentAction = this.actions.shift();
                        }
                    } else if (
                        this.currentAction &&
                        typeof this.currentAction === 'object' &&
                        this.currentAction._isSeries
                    ) {
                        // Execute series actions (sequential)
                        this.currentAction.execute();
                        if (this.currentAction.ended) {
                            this.currentAction = this.actions.shift();
                        }
                    } else if (Array.isArray(this.currentAction)) {
                        // It's an array - execute sequentially
                        if (!this.currentAction._sequentialExecutor) {
                            this.currentAction._sequentialExecutor = this._createSequentialExecutor(
                                this.currentAction
                            );
                        }
                        this.currentAction._sequentialExecutor.execute();
                        if (this.currentAction._sequentialExecutor.ended) {
                            this.currentAction = this.actions.shift();
                        }
                    } else {
                        // It's a single action
                        // Handle async actions
                        if (this.currentAction.isAsync) {
                            if (!this.currentAction.isExecuting) {
                                // Start async execution
                                this.currentAction.execute().catch((error) => {
                                    console.error('Error executing async action:', error);
                                    this.currentAction.ended = true;
                                });
                            }
                            // Check if async action completed
                            if (this.currentAction.ended) {
                                this.currentAction = this.actions.shift();
                            }
                        } else {
                            // Synchronous action
                            this.currentAction.execute();
                            if (this.currentAction.ended) {
                                this.currentAction = this.actions.shift();
                            }
                        }
                    }
                } catch (error) {
                    console.error(error);
                    console.log(this);
                    this.stateQueue.push(IDLE);
                }
            }
            // If we are not performing any actions
        } else {
            // And if there are no more actions in the queue
            if (this.actions.length === 0) {
                // We move to the next State
                this.transitionToNextState();
            } else {
                // Otherwise we grab the next action from the queue (could be a single action, an array, or a parallel/series wrapper)
                this.currentAction = this.actions.shift();
            }
        }
        const p2 = performance.now();
        this.performance = Math.round(p2 - p1);

        // Check for auto-save (only in overworld, not during battle)
        this.checkAutoSave();
    }

    /**
     * Check if auto-save should be triggered and perform it asynchronously
     * Only saves when:
     * - Auto-save is enabled in options menu
     * - Not currently in battle
     * - Not currently loading/initializing
     * - Not in LOAD_GAME state
     * - 5 seconds have passed since last auto-save
     * - Not already saving
     */
    checkAutoSave() {
        // Don't auto-save during battle
        if (this.currentState === BATTLE) {
            return;
        }

        // Don't auto-save during game loading/initialization
        if (this.currentState === LOADING) {
            return;
        }

        // Don't auto-save while loading game
        if (this.currentState === LOAD_GAME) {
            return;
        }

        // Check if auto-save is enabled
        if (this.optionsMenu?.autoSave !== 'on') {
            return;
        }

        // Don't start a new save if one is already in progress
        if (this.isAutoSaving) {
            return;
        }

        // Only auto-save when player is idle (not moving/interacting)
        // Check if we're in a movement state - if so, don't save
        const movementStates = [START_MOVING, MOVING, END_MOVING, CHANGE_DIRECTION];
        if (movementStates.includes(this.currentState)) {
            // Update activity time when player is moving
            this.lastPlayerActivityTime = Date.now();
            return;
        }

        // Only save when in IDLE state (player is stationary)
        if (this.currentState !== IDLE) {
            return;
        }

        // Check if player has been idle long enough
        const now = Date.now();
        const timeSinceLastActivity = now - this.lastPlayerActivityTime;
        if (timeSinceLastActivity < this.idleTimeForAutoSave) {
            return; // Player hasn't been idle long enough
        }

        // Check if 5 seconds have passed since last auto-save
        const timeSinceLastSave = now - this.lastAutoSaveTime;
        if (timeSinceLastSave >= this.autoSaveInterval) {
            // Trigger async auto-save (non-blocking)
            // This happens during natural idle periods, so lag is less noticeable
            this.performAutoSave();
        }
    }

    /**
     * Perform auto-save asynchronously without blocking rendering
     */
    async performAutoSave() {
        if (this.isAutoSaving) {
            return;
        }

        this.isAutoSaving = true;
        this.lastAutoSaveTime = Date.now();

        try {
            await gameSaveManager.saveGame(this);
        } catch (error) {
            console.error('Auto-save failed:', error);
        } finally {
            this.isAutoSaving = false;
        }
    }

    awaitMotionInput() {
        if (this.player.forcedStepCount > 0) {
            return true;
        }

        if (keys.w.pressed || keys.W.pressed) {
            this.player.requestedDirection = UP;
            return true;
        } else if (keys.a.pressed || keys.A.pressed) {
            this.player.requestedDirection = LEFT;
            return true;
        } else if (keys.s.pressed || keys.S.pressed) {
            this.player.requestedDirection = DOWN;
            return true;
        } else if (keys.d.pressed || keys.D.pressed) {
            this.player.requestedDirection = RIGHT;
            return true;
        }
        return false;
    }

    awaitCancelInput() {
        return KPI_K;
    }

    awaitHorizontalOptionInput(option, maxOptions) {
        if (KPI_A) {
            option -= 1;
        } else if (KPI_D) {
            option += 1;
        }

        if (option < 0) {
            option = 0;
        } else if (option > maxOptions - 1) {
            option = maxOptions - 1;
        }

        return { currentOption: option, selected: KPI_L };
    }

    awaitVerticalOptionInput(option, maxOptions, reversed = false) {
        if (KPI_W) {
            option -= 1 * (reversed ? -1 : 1);
        } else if (KPI_S) {
            option += 1 * (reversed ? -1 : 1);
        }

        if (option < 0) {
            option = 0;
        } else if (option > maxOptions - 1) {
            option = maxOptions - 1;
        }
        return { currentOption: option, selected: KPI_L };
    }

    // Current section -> Box List (0), Current Box (1), Party (2)
    awaitPokemonManagementInput() {
        // Press up
        if (KPI_W) {
            if (this.pcMenu.currentSection === 0) {
                this.pcMenu.currentSection = 2;
            } else if (this.pcMenu.currentSection === 1) {
                if (this.pcMenu.row === 0) {
                    this.pcMenu.currentSection = 0;
                } else {
                    this.pcMenu.row -= 1;
                }
            } else if (this.pcMenu.currentSection === 2) {
                this.pcMenu.currentSection = 1;
                this.pcMenu.row = 3;
            }
        }

        // Press down
        if (KPI_S) {
            if (this.pcMenu.currentSection === 0) {
                this.pcMenu.currentSection = 1;
                this.pcMenu.row = 0;
            } else if (this.pcMenu.currentSection === 1) {
                if (this.pcMenu.row === 3) {
                    this.pcMenu.currentSection = 2;
                } else {
                    this.pcMenu.row += 1;
                }
            } else if (this.pcMenu.currentSection === 2) {
                this.pcMenu.currentSection = 0;
            }
        }

        // Press Left
        if (KPI_A) {
            if (this.pcMenu.currentSection === 0) {
                if (this.pcMenu.box === 0) {
                    this.pcMenu.box = this.player.pcPokemon.length - 1;
                } else {
                    this.pcMenu.box -= 1;
                }
            } else if ([1, 2].includes(this.pcMenu.currentSection)) {
                if (this.pcMenu.column === 0) {
                    this.pcMenu.column = 5;
                } else {
                    this.pcMenu.column -= 1;
                }
            }
        }

        // Press Right
        if (KPI_D) {
            if (this.pcMenu.currentSection === 0) {
                if (this.pcMenu.box === this.player.pcPokemon.length - 1) {
                    this.pcMenu.box = 0;
                } else {
                    this.pcMenu.box += 1;
                }
            } else if ([1, 2].includes(this.pcMenu.currentSection)) {
                if (this.pcMenu.column === 5) {
                    this.pcMenu.column = 0;
                } else {
                    this.pcMenu.column += 1;
                }
            }
        }

        if (this.pcMenu.currentSection === 0) {
            this.pcMenu.currentPokemon = null;
        } else if (this.pcMenu.currentSection === 1) {
            this.pcMenu.currentPokemon =
                this.player.pcPokemon[this.pcMenu.box][this.pcMenu.row][this.pcMenu.column];
        } else if (this.pcMenu.currentSection === 2) {
            this.pcMenu.currentPokemon = this.pcMenu.partyList[this.pcMenu.column];
        }

        if (this.pcMenu.selectedPokemon instanceof Pokemon) {
            return KPI_L;
        }

        return KPI_L && this.pcMenu.currentPokemon instanceof Pokemon;
    }

    awaitPokemonOptionInput(option, maxOptions) {
        if (KPI_W) {
            option -= 1;
        } else if (KPI_S) {
            option += 1;
        } else if (KPI_D) {
            if (option === 0) {
                option = 1;
            }
        } else if (KPI_A) {
            if (option !== maxOptions - 1) {
                option = 0;
            }
        }

        if (option < 0) {
            option = maxOptions - 1;
        }
        if (option > maxOptions - 1) {
            option = 0;
        }
        option = option % maxOptions;
        return { currentOption: option, selected: KPI_L };
    }

    awaitInteraction() {
        if (KPI_L && this.interactionBuffer === 0) {
            if (this.adjacentObjects.up && this.player.direction === UP) {
                this.adjacentObjects.up.direction = DOWN;
                return {
                    isInteracting: this.adjacentObjects.up.canInteract() || false,
                    object: this.adjacentObjects.up,
                };
            }
            if (this.adjacentObjects.left && this.player.direction === LEFT) {
                this.adjacentObjects.left.direction = RIGHT;
                return {
                    isInteracting: this.adjacentObjects.left.canInteract() || false,
                    object: this.adjacentObjects.left,
                };
            }
            if (this.adjacentObjects.down && this.player.direction === DOWN) {
                this.adjacentObjects.down.direction = UP;
                return {
                    isInteracting: this.adjacentObjects.down.canInteract() || false,
                    object: this.adjacentObjects.down,
                };
            }
            if (this.adjacentObjects.right && this.player.direction === RIGHT) {
                this.adjacentObjects.right.direction = LEFT;
                return {
                    isInteracting: this.adjacentObjects.right.canInteract() || false,
                    object: this.adjacentObjects.right,
                };
            }
            this.interactionBuffer = 10;
        }
        return { isInteracting: false, object: null };
    }

    shouldChangeDirection() {
        if (this.player.requestedDirection !== this.player.direction) {
            return true;
        }
        return false;
    }

    canMove() {
        if (this.player.forcedStepCount > 0) {
            return true;
        }
        this.updateCollisions();
        if (this.canWalkThroughWalls()) {
            return true;
        }
        if (this.player.direction === DOWN && this.player.requestedDirection === DOWN) {
            return !this.collisions.down;
        }
        if (this.player.direction === LEFT && this.player.requestedDirection === LEFT) {
            return !this.collisions.left;
        }
        if (this.player.direction === RIGHT && this.player.requestedDirection === RIGHT) {
            return !this.collisions.right;
        }
        if (this.player.direction === UP && this.player.requestedDirection === UP) {
            return !this.collisions.up;
        }
        return true;
    }

    alignedToGrid() {
        return this.player.position.x % 16 === 0 && this.player.position.y % 16 === 0;
    }

    alignedToRunningGrid() {
        return this.player.position.x % 2 === 0 && this.player.position.y % 2 === 0;
    }

    /**
     * Creates an OverworldAction that handles player movement.
     * This can be used both in the MOVING state and for triggering movement outside of it.
     * @returns {OverworldAction} An OverworldAction that handles player movement
     */
    createMovingAction() {
        return new OverworldAction({
            startAction: () => {
                this.updateCollisions();
            },
            action: () => {
                let overrideMotionContinuation = false;
                if (KPI___) {
                    this.shouldPause = true;
                }

                if (this.alignedToRunningGrid() && !this.player.biking) {
                    if ((keys.k.pressed || keys.K.pressed) && !this.player.overworldSprite.jumping) {
                        this.movementSpeed = 2;
                        this.player.running = true;
                    } else if (this.player.overworldSprite.jumping) {
                        this.movementSpeed = 1;
                    } else {
                        this.movementSpeed = 1;
                        this.player.running = false;
                    }
                }

                if (this.alignedToGrid()) {
                    this.player.step();
                    if (this.player.biking) {
                        this.movementSpeed = 4;
                    }
                    this.currentMap.verticalPositionControls.forEach((vpc) => {
                        if (vpc.entered()) {
                            this.player.position.z = vpc.nextZ;
                            this.updateCollisions();
                        }
                    });

                    if (!this.canMove()) {
                        this.awaitMotionInput();
                        return this.player.direction === this.player.requestedDirection;
                    }

                    if (
                        this.adjacentObjects.center instanceof DownLedge ||
                        this.adjacentObjects.center instanceof LeftLedge ||
                        this.adjacentObjects.center instanceof RightLedge
                    ) {
                        this.movementSpeed = 1;
                        overrideMotionContinuation = true;
                    }

                    let currentEncounterRate = 0;
                    if (this.adjacentObjects.center instanceof BattleZone) {
                        if (this.arrivedInGridCell()) {
                            if (!this.justBattled) {
                                currentEncounterRate = this.currentLocation.encounterRate;
                                this.adjacentObjects.center.ruffleGrass();
                            } else {
                                this.justBattled = false;
                            }
                        }
                    }

                    // Check for wild battle encounter (skip if cheat is enabled)
                    if (!this.shouldSkipWildBattles() && Math.random() < currentEncounterRate) {
                        this.stateQueue.push(START_BATTLE);
                        return true;
                    }

                    if (this.shouldPause) {
                        this.stateQueue.push(PAUSE_MENU);
                        this.shouldPause = false;
                        return true;
                    }

                    if (this.checkZoneInteractions()) {
                        return true;
                    }

                    // Handle diagonal movement controls (MOVING-specific)
                    const activeDmc = this.currentMap.diagonalMovementControls.find((dmc) => dmc.entered());
                    if (activeDmc) {
                        this.player.diagonalDirection = activeDmc.direction;
                    } else {
                        this.player.diagonalDirection = null;
                    }

                    if (!this.awaitMotionInput() && !overrideMotionContinuation) {
                        return true;
                    }

                    if (this.shouldChangeDirection()) {
                        // Already moving so we change direction immediately
                        if (
                            !(
                                this.adjacentObjects.center instanceof DownLedge ||
                                this.adjacentObjects.center instanceof LeftLedge ||
                                this.adjacentObjects.center instanceof RightLedge
                            )
                        ) {
                            this.player.direction = this.player.requestedDirection;
                        }
                    }
                }

                if (this.canMove()) {
                    if (this.player.direction === DOWN) {
                        if (this.adjacentObjects.down instanceof DownLedge) {
                            this.GUI.sprites.player.jump();
                            this.movementSpeed = 1;
                        }
                        this.player.position.y += this.movementSpeed;
                    }

                    if (this.player.direction === LEFT) {
                        if (this.adjacentObjects.left instanceof LeftLedge) {
                            this.GUI.sprites.player.jump();
                            this.movementSpeed = 1;
                        }
                        this.player.position.x -= this.movementSpeed;
                        switch (this.player.diagonalDirection) {
                            case 'up_right':
                                this.player.position.y += 0 * this.movementSpeed;
                                break;
                            case 'up_left':
                                this.player.position.y -= 1 * this.movementSpeed;
                                break;
                            case 'down_left':
                                this.player.position.y += 1 * this.movementSpeed;
                                break;
                            case 'down_right':
                                this.player.position.y -= 0 * this.movementSpeed;
                                break;
                            case 'up_right_down_left':
                                this.player.position.y += 1 * this.movementSpeed;
                                break;
                            case 'up_left_down_right':
                                this.player.position.y -= 1 * this.movementSpeed;
                                break;
                        }
                    }

                    if (this.player.direction === RIGHT) {
                        if (this.adjacentObjects.right instanceof RightLedge) {
                            this.GUI.sprites.player.jump();
                            this.movementSpeed = 1;
                        }
                        this.player.position.x += this.movementSpeed;
                        switch (this.player.diagonalDirection) {
                            case 'up_right':
                                this.player.position.y -= 1 * this.movementSpeed;
                                break;
                            case 'up_left':
                                this.player.position.y += 0 * this.movementSpeed;
                                break;
                            case 'down_left':
                                this.player.position.y -= 0 * this.movementSpeed;
                                break;
                            case 'down_right':
                                this.player.position.y += 1 * this.movementSpeed;
                                break;
                            case 'up_right_down_left':
                                this.player.position.y -= 1 * this.movementSpeed;
                                break;
                            case 'up_left_down_right':
                                this.player.position.y += 1 * this.movementSpeed;
                                break;
                        }
                    }

                    if (this.player.direction === UP) {
                        this.player.position.y -= this.movementSpeed;
                    }
                } else {
                    console.log('cant move...');
                }

                return false;
            },
            endAction: () => {
                if (this.adjacentObjects.center instanceof LandEntryZone) {
                    this.player.surfing = false;
                }
                if (this.adjacentObjects.center instanceof WaterEntryZone) {
                    this.player.surfing = true;
                }
            },
        });
    }

    calculateMovementsForPosition({ object = this.player, fromPosition, toPosition, skipCollisions = false }) {
        // Use fromPosition if provided, otherwise use object's current position
        const startPos = fromPosition || object.position;

        // Step 1: Initialize 15x15 collision map
        const collisionMap = Array(15)
            .fill(null)
            .map(() => Array(15).fill(false));

        // Step 2: Validate target position and convert to grid coordinates
        const objectGridX = Math.floor(startPos.x / 16);
        const objectGridY = Math.floor(startPos.y / 16);
        const objectZ = startPos.z;

        const targetGridX = Math.floor(toPosition.x / 16);
        const targetGridY = Math.floor(toPosition.y / 16);

        // Calculate relative position in the 15x15 grid (center is at [8][8])
        const relativeGridX = targetGridX - objectGridX + 8;
        const relativeGridY = targetGridY - objectGridY + 8;

        // Validate target is within bounds
        if (relativeGridX < 0 || relativeGridX >= 15 || relativeGridY < 0 || relativeGridY >= 15) {
            throw new Error(
                `Target position is outside the 15x15 grid bounds. Relative position: (${relativeGridX}, ${relativeGridY})`
            );
        }

        // Step 3: Populate collision map with boundaries, NPCs, and trainers
        if (!skipCollisions) {
            const allCollisionObjects = [
                ...this.currentMap.boundaries,
                ...this.currentMap.npcs,
                ...this.currentMap.trainers,
                this.player,
            ];

            for (const obj of allCollisionObjects) {
                if (obj.position.z !== objectZ) continue;
                if (obj === object) continue;

                const objGridX = Math.floor(obj.position.x / 16);
                const objGridY = Math.floor(obj.position.y / 16);

                const relativeObjX = objGridX - objectGridX + 8;
                const relativeObjY = objGridY - objectGridY + 8;

                if (relativeObjX >= 0 && relativeObjX < 15 && relativeObjY >= 0 && relativeObjY < 15) {
                    collisionMap[relativeObjY][relativeObjX] = true;
                }
            }

            collisionMap[relativeGridY][relativeGridX] = false;
        }

        // Step 4: BFS pathfinding from (8, 8) to target
        const startX = 8;
        const startY = 8;
        const targetX = relativeGridX;
        const targetY = relativeGridY;

        // BFS queue: [x, y, path]
        const queue = [[startX, startY, []]];
        const visited = new Set();
        visited.add(`${startX},${startY}`);

        // Directions: up, down, left, right
        const directions = [
            [0, -1], // up
            [0, 1], // down
            [-1, 0], // left
            [1, 0], // right
        ];

        while (queue.length > 0) {
            const [x, y, path] = queue.shift();

            // Check if we reached the target
            if (x === targetX && y === targetY) {
                // Step 5: Convert path to movement objects
                return this.convertPathToMovements(path);
            }

            // Explore neighbors
            for (const [dx, dy] of directions) {
                const newX = x + dx;
                const newY = y + dy;
                const key = `${newX},${newY}`;

                // Check bounds and collisions
                if (
                    newX >= 0 &&
                    newX < 15 &&
                    newY >= 0 &&
                    newY < 15 &&
                    !collisionMap[newY][newX] &&
                    !visited.has(key)
                ) {
                    visited.add(key);
                    // Determine direction for this step
                    let direction;
                    if (dx === 0 && dy === -1) direction = 'up';
                    else if (dx === 0 && dy === 1) direction = 'down';
                    else if (dx === -1 && dy === 0) direction = 'left';
                    else if (dx === 1 && dy === 0) direction = 'right';

                    queue.push([newX, newY, [...path, direction]]);
                }
            }
        }

        // No path found
        throw new Error('No path found to target position');
    }

    convertPathToMovements(path) {
        if (path.length === 0) return [];

        const movements = [];
        let currentDirection = path[0];
        let currentSteps = 1;

        for (let i = 1; i < path.length; i++) {
            if (path[i] === currentDirection) {
                currentSteps++;
            } else {
                // Add current movement
                movements.push({ [currentDirection]: currentSteps });
                // Start new direction
                currentDirection = path[i];
                currentSteps = 1;
            }
        }

        // Add the last movement
        movements.push({ [currentDirection]: currentSteps });
        return movements;
    }

    /**
     * Creates an OverworldAction that moves the player through a sequence of movements.
     * @param {Array<Object>} movements - Array of movement objects, e.g. [{up: 4}, {right: 2}]
     * @returns {OverworldAction} An OverworldAction that handles the movement sequence
     */
    movePlayer(movements) {
        // Parse movements into a structured format

        // Track state

        this.actions.push(
            new OverworldAction({
                startAction: () => {
                    this.context.movementSequence = movements.map((movement) => {
                        const direction = Object.keys(movement)[0];
                        const steps = movement[direction];
                        return { direction, steps };
                    });
                    this.context.currentMovementIndex = 0;
                    this.context.previousForcedStepCount = 0;
                    // Initialize first movement
                    if (this.context.movementSequence.length > 0) {
                        const firstMovement = this.context.movementSequence[0];
                        this.player.direction = firstMovement.direction;
                        this.player.requestedDirection = firstMovement.direction;
                        this.player.forcedStepCount = firstMovement.steps;
                        this.context.previousForcedStepCount = firstMovement.steps;
                    }
                    this.updateCollisions();
                },
                action: () => {
                    // Check if we've completed all movements
                    this.GUI.sprites.player.moving = true;
                    if (this.context.currentMovementIndex >= this.context.movementSequence.length) {
                        return true;
                    }

                    // Store forcedStepCount before it might be decremented
                    const currentForcedStepCount = this.player.forcedStepCount;

                    // Check if we need to switch to next direction
                    // This happens when aligned to grid and forcedStepCount was just decremented to 0
                    if (this.alignedToGrid()) {
                        // If forcedStepCount just reached 0 (was > 0 last frame, now 0)
                        if (currentForcedStepCount === 0 && this.context.previousForcedStepCount > 0) {
                            // Move to next movement
                            this.context.currentMovementIndex++;

                            // If there are more movements, initialize next one
                            if (this.context.currentMovementIndex < this.context.movementSequence.length) {
                                const nextMovement =
                                    this.context.movementSequence[this.context.currentMovementIndex];
                                this.player.direction = nextMovement.direction;
                                this.player.requestedDirection = nextMovement.direction;
                                this.player.forcedStepCount = nextMovement.steps;
                                this.context.previousForcedStepCount = nextMovement.steps;
                            } else {
                                // All movements complete
                                this.player.forcedStepCount = 0;
                                return true;
                            }
                        }
                    }

                    // Update previousForcedStepCount for next frame comparison
                    // This captures the value BEFORE player.step() might decrement it
                    // We update it here so it's always current, whether aligned or not
                    if (this.alignedToGrid()) {
                        this.context.previousForcedStepCount = currentForcedStepCount;
                    }

                    // Handle pause
                    if (KPI___) {
                        this.shouldPause = true;
                    }

                    // Handle running speed
                    if (this.alignedToRunningGrid() && !this.player.biking) {
                        if ((keys.k.pressed || keys.K.pressed) && !this.player.overworldSprite.jumping) {
                            this.movementSpeed = 2;
                            this.player.running = true;
                        } else if (this.player.overworldSprite.jumping) {
                            this.movementSpeed = 1;
                        } else {
                            this.movementSpeed = 1;
                            this.player.running = false;
                        }
                    }

                    // Handle grid alignment and step counting
                    if (this.alignedToGrid()) {
                        this.player.step();
                        if (this.player.biking) {
                            this.movementSpeed = 4;
                        }

                        // Handle vertical position controls
                        this.currentMap.verticalPositionControls.forEach((vpc) => {
                            if (vpc.entered()) {
                                this.player.position.z = vpc.nextZ;
                                this.updateCollisions();
                            }
                        });

                        // Check collisions
                        if (!this.canMove()) {
                            // Can't move due to collision, but forcedStepCount will keep trying
                            // We'll just wait here
                            return false;
                        }

                        // Handle ledge collisions
                        if (
                            this.adjacentObjects.center instanceof DownLedge ||
                            this.adjacentObjects.center instanceof LeftLedge ||
                            this.adjacentObjects.center instanceof RightLedge
                        ) {
                            this.movementSpeed = 1;
                        }

                        // Handle zone interactions (warp zones, event triggers, etc.)
                        if (this.checkZoneInteractions()) {
                            return true;
                        }

                        // Handle diagonal movement controls
                        const activeDmc = this.currentMap.diagonalMovementControls.find((dmc) =>
                            dmc.entered()
                        );
                        if (activeDmc) {
                            this.player.diagonalDirection = activeDmc.direction;
                        } else {
                            this.player.diagonalDirection = null;
                        }
                    }

                    // Perform actual movement
                    if (this.canMove() && this.player.forcedStepCount > 0) {
                        if (this.player.direction === DOWN) {
                            if (this.adjacentObjects.down instanceof DownLedge) {
                                this.GUI.sprites.player.jump();
                                this.movementSpeed = 1;
                            }
                            this.player.position.y += this.movementSpeed;
                        }

                        if (this.player.direction === LEFT) {
                            if (this.adjacentObjects.left instanceof LeftLedge) {
                                this.GUI.sprites.player.jump();
                                this.movementSpeed = 1;
                            }
                            this.player.position.x -= this.movementSpeed;
                            switch (this.player.diagonalDirection) {
                                case 'up_right':
                                    this.player.position.y += 0 * this.movementSpeed;
                                    break;
                                case 'up_left':
                                    this.player.position.y -= 1 * this.movementSpeed;
                                    break;
                                case 'down_left':
                                    this.player.position.y += 1 * this.movementSpeed;
                                    break;
                                case 'down_right':
                                    this.player.position.y -= 0 * this.movementSpeed;
                                    break;
                                case 'up_right_down_left':
                                    this.player.position.y += 1 * this.movementSpeed;
                                    break;
                                case 'up_left_down_right':
                                    this.player.position.y -= 1 * this.movementSpeed;
                                    break;
                            }
                        }

                        if (this.player.direction === RIGHT) {
                            if (this.adjacentObjects.right instanceof RightLedge) {
                                this.GUI.sprites.player.jump();
                                this.movementSpeed = 1;
                            }
                            this.player.position.x += this.movementSpeed;
                            switch (this.player.diagonalDirection) {
                                case 'up_right':
                                    this.player.position.y -= 1 * this.movementSpeed;
                                    break;
                                case 'up_left':
                                    this.player.position.y += 0 * this.movementSpeed;
                                    break;
                                case 'down_left':
                                    this.player.position.y -= 0 * this.movementSpeed;
                                    break;
                                case 'down_right':
                                    this.player.position.y += 1 * this.movementSpeed;
                                    break;
                                case 'up_right_down_left':
                                    this.player.position.y -= 1 * this.movementSpeed;
                                    break;
                                case 'up_left_down_right':
                                    this.player.position.y += 1 * this.movementSpeed;
                                    break;
                            }
                        }

                        if (this.player.direction === UP) {
                            this.player.position.y -= this.movementSpeed;
                        }
                    }

                    // Continue until all movements are complete
                    return false;
                },
                endAction: () => {
                    // Clean up
                    this.player.moving = false;
                    getGUI().sprites.player.moving = false;
                    this.player.forcedStepCount = 0;
                    if (this.adjacentObjects.center instanceof LandEntryZone) {
                        this.player.surfing = false;
                    }
                    if (this.adjacentObjects.center instanceof WaterEntryZone) {
                        this.player.surfing = true;
                    }
                },
            })
        );
    }

    getCurrentEvent() {
        if (this.context.currentEvent instanceof BaseEvent) {
            return this.context.currentEvent;
        }
        return null;
    }

    warpToLocation(warpZone) {
        if (this.availableMaps[warpZone.destinationMap] === undefined) {
            this.currentMap = availableMaps[warpZone.destinationMap];
            this.availableMaps[warpZone.destinationMap] = this.currentMap;
        } else {
            this.currentMap = this.availableMaps[warpZone.destinationMap];
        }
        this.currentMap.flashWasAttempted = false;
        const destinationWarpZonePosition = this.currentMap.warpZones.find(
            (wz) => wz.identifier === warpZone.destinationWarpZone
        ).position;
        this.player.position = {
            x: destinationWarpZonePosition.x + warpZone.destinationXOffset,
            y: destinationWarpZonePosition.y + warpZone.destinationYOffset,
            z: destinationWarpZonePosition.z,
        };
        if (!this.currentMap.canBike) {
            this.player.biking = false;
        }
        if (warpZone.destinationDirection) {
            this.player.direction = warpZone.destinationDirection;
        }
        this.GUI.setup();
    }

    enterLocation(locationId) {
        this.currentLocation = Location.get(locationId);
        console.log(`Entered ${this.currentLocation.name}`);
        this.GUI.locationBanner.show();
    }

    getCurrentLocation() {
        return this.currentLocation;
    }

    getCurrentMap() {
        return this.currentMap;
    }

    readTextAndWait(text) {
        this.actions.push(
            new OverworldAction({
                startAction: () => {
                    // Reset cursor when starting a new text action
                    this.cursor = 0;
                    // Reset scroll position when starting new text
                    if (getGUI() && getGUI().overworldText) {
                        getGUI().overworldText.resetToOriginalPosition();
                    }
                },
                action: () => {
                    this.player.running = false;
                    this.GUI.sprites.player.frames.val = 0;
                    this.overworldText = typeof text === 'function' ? text() : text;
                    return this.cursor >= this.overworldText.length;
                },
            })
        );
    }

    readText(text, options = {}) {
        const { showContinueArrow = true, speaker = null } = options;
        this.actions.push(
            new OverworldAction({
                startAction: () => {
                    // Reset cursor when starting a new text action
                    this.cursor = 0;
                    // Reset scroll position when starting new text
                    if (getGUI() && getGUI().overworldText) {
                        getGUI().overworldText.resetToOriginalPosition();
                        // Set continue arrow visibility option
                        getGUI().overworldText.showContinueArrow = showContinueArrow;
                    }
                    if (speaker !== null) {
                        this.overworldTextSpeaker = typeof speaker === 'function' ? speaker() : speaker;
                    }
                },
                action: () => {
                    // Support lazy evaluation: if text is a function, evaluate it when the action executes
                    this.player.running = false;
                    this.GUI.sprites.player.frames.val = 0;
                    this.overworldText = typeof text === 'function' ? text() : text;
                    return true;
                },
            })
        );
    }

    finishReading = () => {
        this.actions.push(
            new OverworldAction({
                action: () => {
                    // Check if text is waiting for scroll input
                    if (this.GUI && this.GUI.overworldText && this.GUI.overworldText.waitingForUserInput()) {
                        // Don't finish reading if still waiting for scroll
                        return false;
                    }
                    return (KPI_L || KPI_K) && this.cursor >= this.overworldText.length;
                },
                endAction: () => {
                    // Reset scroll position when finishing reading
                    if (this.GUI && this.GUI.overworldText) {
                        this.GUI.overworldText.resetToOriginalPosition();
                    }
                    this.overworldText = '';
                    this.overworldTextSpeaker = '';
                },
            })
        );
    };

    continueReading = () => {
        this.actions.push(
            new OverworldAction({
                action: () => {
                    return (KPI_L || KPI_K) && this.cursor >= this.overworldText.length;
                },
                endAction: () => {
                    this.overworldText = ' ';
                },
            })
        );
    };

    clearText() {
        this.script(() => {
            this.overworldText = '';
            this.overworldTextSpeaker = '';
            this.cursor = 0;
            return true;
        });
    }

    autoContinueReading = () => {
        this.actions.push(
            new OverworldAction({
                action: () => {
                    return this.cursor >= this.overworldText.length;
                },
            })
        );
    };

    script(s) {
        // Detect if the script function is async
        // Check if it's an async function by checking its constructor name
        const isAsyncFunction =
            typeof s === 'function' &&
            (s.constructor.name === 'AsyncFunction' ||
                Object.prototype.toString.call(s) === '[object AsyncFunction]');

        // Always wrap in async function to handle both async functions and functions that return Promises
        this.actions.push(
            new OverworldAction({
                action: async () => {
                    const result = await s();
                    return result !== false; // Return true unless explicitly false
                },
                isAsync: isAsyncFunction, // Mark as async if it's an async function
            })
        );
    }

    delay(amount) {
        this.script(() => {
            this.context.stateMachineDelay = 0;
        });
        this.actions.push(
            new OverworldAction({
                startAction: () => {
                    this.context.stateMachineDelay = amount;
                },
                action: () => {
                    this.context.stateMachineDelay -= 1;
                    return this.context.stateMachineDelay === 0;
                },
            })
        );
    }

    delayWithCancel(amount) {
        this.script(() => {
            this.context.stateMachineDelay = 0;
        });
        this.actions.push(
            new OverworldAction({
                startAction: () => {
                    this.context.stateMachineDelay = amount;
                },
                action: () => {
                    this.context.stateMachineDelay -= 1;
                    if (KPI_L || KPI_K || KPI___) {
                        this.context.stateMachineDelay = 0;
                    }
                    return this.context.stateMachineDelay === 0;
                },
            })
        );
    }

    undarkenScreen = () => {
        this.actions.push(
            new OverworldAction({
                action: () => {
                    return this.GUI.undarken();
                },
            })
        );
    };

    darkenScreen = (rate = 0.1) => {
        this.actions.push(
            new OverworldAction({
                action: () => {
                    return this.GUI.darken(rate);
                },
            })
        );
    };

    activateBattle = (options) => {
        this.context.inBattle = true;
        this.actions.push(
            new OverworldAction({
                action: () => {
                    this.player.overworldSprite.moving = false;
                    this.player.running = false;

                    // Add pokemon to pokemon log
                    const newPokemonChoices = [];

                    let currentlyAvailablePokemon = this.currentLocation.getAvailableLandPokemon(
                        getGUI().getTimeOfDay()
                    );
                    let encounterType = this.adjacentObjects.center?.encounterType;
                    // HM-triggered encounters (cut / rock_smash) come from options
                    if (options?.encounterType === 'cut') {
                        currentlyAvailablePokemon = this.currentLocation.getAvailableCutPokemon();
                        encounterType = 'cut';
                    } else if (options?.encounterType === 'rock_smash') {
                        currentlyAvailablePokemon = this.currentLocation.getAvailableRockSmashPokemon();
                        encounterType = 'rock_smash';
                    } else if (this.adjacentObjects.center) {
                        switch (encounterType) {
                            case 'land':
                                currentlyAvailablePokemon = this.currentLocation.getAvailableLandPokemon();
                                break;
                            case 'water':
                                currentlyAvailablePokemon = this.currentLocation.getAvailableWaterPokemon();
                                break;
                        }
                    }

                    currentlyAvailablePokemon.forEach((p) => {
                        // Only add if pokemonId exists
                        if (p && p.pokemonId !== undefined && p.pokemonId !== null) {
                            for (let i = 0; i < (p.chance || 1); i++) {
                                newPokemonChoices.push(p);
                            }
                        }
                    });

                    // Safety check: ensure we have Pokemon choices
                    if (newPokemonChoices.length === 0) {
                        console.error(
                            'No available Pokemon for encounter. Location:',
                            this.currentLocation?.name,
                            'Available Pokemon:',
                            currentlyAvailablePokemon
                        );
                        return; // Exit early if no Pokemon available
                    }

                    const randomizedIndex = Math.floor(Math.random() * newPokemonChoices.length);
                    const selectedPokemon = newPokemonChoices[randomizedIndex];

                    // Safety check: ensure pokemonId exists
                    if (
                        !selectedPokemon ||
                        selectedPokemon.pokemonId === undefined ||
                        selectedPokemon.pokemonId === null
                    ) {
                        console.error('Selected Pokemon has no pokemonId:', selectedPokemon);
                        return; // Exit early if pokemonId is missing
                    }

                    const minLevel = selectedPokemon.minLevel ?? 5;
                    const maxLevel = selectedPokemon.maxLevel ?? selectedPokemon.minLevel ?? 5;

                    let newPokemonLevel = minLevel + Math.round(Math.random() * (maxLevel - minLevel));

                    // Hustle overworld effect: If a Pokemon with Hustle is in the first slot (even if fainted),
                    // 50% chance to force Pokemon to upper bound of encounter level range
                    if (
                        this.player.party &&
                        this.player.party[0] &&
                        this.player.party[0].ability?.identifier === 'hustle'
                    ) {
                        if (Math.random() < 0.5) {
                            newPokemonLevel = maxLevel;
                            console.log(
                                `Hustle overworld effect: ${this.player.party[0].name} forced to level ${maxLevel}`
                            );
                        }
                    }

                    // Ensure pokemonId is a number
                    let pokemonId = parseInt(selectedPokemon.pokemonId, 10);
                    if (isNaN(pokemonId)) {
                        console.error('Invalid pokemonId:', selectedPokemon.pokemonId);
                        return;
                    }

                    // Wild encounter cheats: each option is independent (forced pokemon, level, item)
                    const forcedPokemonName = this.optionsMenu?.overworldCheatForcedPokemon;
                    const forceLevel = this.optionsMenu?.overworldCheatForceSpecificLevel;
                    if (forcedPokemonName && forcedPokemonName !== 'off') {
                        const { nameToId } = OptionsMenu.getRegionPokedexEncounterData();
                        const forcedId = nameToId[forcedPokemonName];
                        if (forcedId !== undefined) {
                            pokemonId = forcedId;
                        }
                    }
                    if (forceLevel && forceLevel !== 'off') {
                        newPokemonLevel = Math.min(100, Math.max(1, parseInt(forceLevel, 10) || 1));
                    } else if (forcedPokemonName && forcedPokemonName !== 'off') {
                        newPokemonLevel = minLevel + Math.round(Math.random() * (maxLevel - minLevel));
                    }
                    // (when only level is forced, newPokemonLevel is set above; when only pokemon, level stays from encounter roll)

                    const newPokemon =
                        options?.pokemon === undefined
                            ? new Pokemon({
                                  id: pokemonId,
                                  level: newPokemonLevel,
                              })
                            : options.pokemon;
                    newPokemon.frontSprite.position.x = -32 - 64;
                    newPokemon.frontSprite.position.y = 16;

                    // Held item: forced item (if set) or roll from encounter's encounterItems
                    const forcedItemId = this.optionsMenu?.overworldCheatForcedItem;
                    if (forcedItemId && forcedItemId !== 'off') {
                        try {
                            newPokemon.heldItem = ItemFactory.create(forcedItemId);
                        } catch (_) {
                            // Item not in game's item store; leave heldItem null
                        }
                    } else if (options?.pokemon === undefined && selectedPokemon.encounterItems?.length > 0) {
                        const roll = Math.random();
                        let cumulative = 0;
                        for (const entry of selectedPokemon.encounterItems) {
                            const prob = Number(entry.probability);
                            if (!Number.isFinite(prob) || prob <= 0) continue;
                            cumulative += prob;
                            if (roll < cumulative) {
                                const identifier = entry.item?.identifier;
                                if (identifier !== null && identifier !== undefined && String(identifier).trim() !== '') {
                                    try {
                                        newPokemon.heldItem = ItemFactory.create(String(identifier));
                                    } catch (_) {
                                        // Item not in game's item store; leave heldItem null
                                    }
                                }
                                break;
                            }
                        }
                        // If roll >= cumulative, Pokemon holds no item (leave newPokemon.heldItem as null)
                    }

                    function resetBattleUI(player, osm) {
                        spriteStore.store.playerBack.position = {
                            x: 240 + 32,
                            y: 80 - 16,
                        };

                        const arenaImages = osm.currentMap.getBattleArenaImages();
                        if (osm.context.npcSeenBy) {
                            if (player.surfing) {
                                spriteStore.store.battleBackgroundPlayer.setImage(
                                    arenaImages.water.playerStageImage
                                );
                                spriteStore.store.battleBackgroundFoe.setImage(
                                    arenaImages.water.foeStageImage
                                );
                                spriteStore.store.battleBackgroundNoStage.setImage(
                                    arenaImages.water.backgroundImage
                                );
                            } else {
                                spriteStore.store.battleBackgroundPlayer.setImage(
                                    arenaImages.land.playerStageImage
                                );
                                spriteStore.store.battleBackgroundFoe.setImage(
                                    arenaImages.land.foeStageImage
                                );
                                spriteStore.store.battleBackgroundNoStage.setImage(
                                    arenaImages.land.backgroundImage
                                );
                            }
                        } else {
                            switch (encounterType) {
                                case 'land':
                                    spriteStore.store.battleBackgroundPlayer.setImage(
                                        arenaImages.land.playerStageImage
                                    );
                                    spriteStore.store.battleBackgroundFoe.setImage(
                                        arenaImages.land.foeStageImage
                                    );
                                    spriteStore.store.battleBackgroundNoStage.setImage(
                                        arenaImages.land.backgroundImage
                                    );
                                    break;
                                case 'water':
                                    spriteStore.store.battleBackgroundPlayer.setImage(
                                        arenaImages.water.playerStageImage
                                    );
                                    spriteStore.store.battleBackgroundFoe.setImage(
                                        arenaImages.water.foeStageImage
                                    );
                                    spriteStore.store.battleBackgroundNoStage.setImage(
                                        arenaImages.water.backgroundImage
                                    );
                                    break;
                                case 'cut':
                                case 'rock_smash':
                                    spriteStore.store.battleBackgroundPlayer.setImage(
                                        arenaImages.land.playerStageImage
                                    );
                                    spriteStore.store.battleBackgroundFoe.setImage(
                                        arenaImages.land.foeStageImage
                                    );
                                    spriteStore.store.battleBackgroundNoStage.setImage(
                                        arenaImages.land.backgroundImage
                                    );
                                    break;
                            }
                        }

                        spriteStore.store.battleScenePlayerInfo.position = {
                            x: 240,
                            y: 96 - 23,
                        };
                        spriteStore.store.battleBackgroundPlayer.position = {
                            x: 240,
                            y: 0,
                        };
                        spriteStore.store.playerBackBoy.position = { x: 240 + 32, y: 80 - 16 };
                        spriteStore.store.playerBackGirl.position = { x: 240 + 32, y: 80 - 16 };

                        spriteStore.store.battleBackgroundFoe.position = {
                            x: -240,
                            y: 0,
                        };
                        spriteStore.store.battleSceneFoeInfo.position = {
                            x: -120,
                            y: 0,
                        };

                        player.party[0].backSprite.scale = 0;
                    }

                    resetBattleUI(this.player, this);

                    const battleGUI = new BattleGUI();
                    let pokemonToSendOut = this.player.party[0];

                    this.player.party.toReversed().forEach((p) => {
                        if (p.stats.hp > 0) {
                            pokemonToSendOut = p;
                        }
                    });
                    console.log(pokemonToSendOut);
                    this.battleStateMachine = new BattleStateMachine({
                        foePokemon: this.context.npcSeenBy ? this.context.npcSeenBy.party[0] : newPokemon,
                        playerPokemon: pokemonToSendOut,
                        battleGUI,
                        player: this.player,
                        foeTrainer: this.context.npcSeenBy,
                    });
                    this.battleStateMachine.battleGUI.setup();
                    this.battleStateMachine.setupActionsForCurrentState(options);
                    // Transition to BATTLE before starting the loop so isInBattle() is true when
                    // the battle loop runs (it may run before the next overworld transitionToNextState).
                    this.currentState = BATTLE;
                    battleAnimationLoop();
                    return true;
                },
            })
        );
    };

    askYesOrNo = (resetCursor = true) => {
        this.actions.push(
            new OverworldAction({
                startAction: () => {
                    this.isAskingYesOrNo = true;
                    this.yesOrNoOption = 0;
                },
                action: () => {
                    this.cursor = this.overworldText.length;

                    if (KPI_K) {
                        // Cancel out
                        this.yesOrNoOption = 1;
                        return true;
                    }

                    this.yesOrNoOption = this.awaitVerticalOptionInput(this.yesOrNoOption, 2).currentOption;
                    return this.awaitVerticalOptionInput(this.yesOrNoOption, 2).selected;
                },
                endAction: () => {
                    this.isAskingYesOrNo = false;
                    if (resetCursor) {
                        this.cursor = 0;
                        this.overworldText = ' ';
                    }
                },
            })
        );
    };

    setupActionsForCurrentState() {
        if (this.currentState !== BATTLE) {
            console.log(`-- Starting State: ${this.currentState} --`);
        }
        const d = this.GUI;

        const useFlash = () => {
            this.actions.push(
                new OverworldAction({
                    startAction: () => {
                        console.log('starting to use flash');
                    },
                    action: () => {
                        return this.GUI.useFlash();
                    },
                    endAction: () => {
                        this.flashWasAttempted = true;
                        console.log('ending use of flash');
                    },
                })
            );
        };

        const isInteracting = () => {
            const isInteracting = this.awaitInteraction().isInteracting; // Whether the player is interacting with something
            const object = this.awaitInteraction().object; // What the player is interacting with

            if (this.interactionBuffer <= 0) {
                this.interactionBuffer = 0;
            } else {
                this.interactionBuffer -= 1;
            }
            if (isInteracting && this.interactionBuffer === 0) {
                this.interactionBuffer = 10;
                // Decide type of interaction
                switch (object.constructor.name) {
                    case 'TextSource':
                        this.stateQueue.push(READ_TEXT_SOURCE);
                        break;
                    case 'NPC':
                        this.activeNPC = object;
                        this.stateQueue.push(INTERACT_WITH_NPC);
                        break;
                    case 'Trainer':
                        if (object.isDefeated) {
                            this.stateQueue.push(READ_TEXT_SOURCE);
                        }
                        break;
                    case 'HealingLocation':
                        this.stateQueue.push(INTERACT_WITH_HEALING_LOCATION);
                        break;
                    case 'MartLocation':
                        this.stateQueue.push(INTERACT_WITH_MART_LOCATION);
                        break;
                    case 'OverworldItem':
                        this.stateQueue.push(ACQUIRE_OVERWORLD_ITEM);
                        break;
                    case 'HMTree':
                        this.context.currentTree = object;
                        this.stateQueue.push(INTERACT_WITH_HM_TREE);
                        break;
                    case 'HMRock':
                        this.context.currentRock = object;
                        this.stateQueue.push(INTERACT_WITH_HM_ROCK);
                        break;
                    case 'PCLocation':
                        this.context.currentPC = object;
                        this.stateQueue.push(BOOT_UP_PC);
                        break;
                    case 'StaticEncounter':
                        this.context.currentStaticEncounter = object;
                        this.stateQueue.push(INTERACT_WITH_STATIC_ENCOUNTER);
                        break;
                    case 'EventTrigger':
                        object.interact();
                        break;
                }
                return true;
            }
            return false;
        };

        switch (this.currentState) {
            case SAVE_FILE_SELECT:
                this.menuHandler.handleSaveFileMenu();
                break;
            case INTRO_CREDITS:
                this.undarkenScreen(0.05);
                this.delayWithCancel(240);
                this.darkenScreen(0.05);
                break;
            case SAVE_FILE_INCOMPATIBLE:
                this.undarkenScreen(0.01);
                this.readText('Your save file is incompatible with the current version of pkmng.');
                this.continueReading();
                this.readText('Unfortunately, it is no longer valid and must be deleted.');
                this.continueReading();
                this.darkenScreen(0.05);
                break;
            case CHECK_AUTH:
                this.script(async () => {
                    const isAuthenticated = await window.gameAuth.checkAuth();
                    if (isAuthenticated) {
                        this.stateQueue.push(SAVE_FILE_SELECT);
                    } else {
                        // Check for access code in query parameters
                        const urlParams = new URLSearchParams(window.location.search);
                        const accessCode = urlParams.get('accessCode');

                        if (accessCode) {
                            console.log(
                                'Attempting to authenticate with access code from query parameters...'
                            );
                            const result = await window.gameAuth.validateAccessCode(accessCode);

                            if (result.success) {
                                console.log('Access code from query parameters verified.');
                                window.gameAuth.setAuth(result.authToken, result.user);
                                this.stateQueue.push(SAVE_FILE_SELECT);
                            } else {
                                console.log('Invalid access code in query parameters.');
                                this.stateQueue.push(NEW_UNAUTHORIZED_SESSION_STARTED);
                            }
                        } else {
                            this.stateQueue.push(NEW_UNAUTHORIZED_SESSION_STARTED);
                        }
                    }
                });
                break;
            case NEW_UNAUTHORIZED_SESSION_STARTED:
                this.undarkenScreen(0.01);
                this.readText('Hello!');
                this.continueReading();
                this.readText(`Please enter the game access code to continue.`);
                this.finishReading();
                this.darkenScreen(0.1);
                this.script(() => this.stateQueue.push(SET_ACCESS_CODE));
                break;
            case SET_ACCESS_CODE:
                this.stateQueue.push(VERIFY_ACCESS_CODE);
                this.undarkenScreen(0.1);
                this.menuHandler.handleKeyboardMenu({
                    targetDisplayText: 'Enter access code:',
                    targetType: 'accessCode',
                    defaultText: '',
                    cancelOnEmpty: true,
                });
                this.darkenScreen(0.1);
                break;
            case VERIFY_ACCESS_CODE:
                this.undarkenScreen(0.1);
                this.script(async () => {
                    const accessCode = this.keyboardMenu.output;
                    const result = await window.gameAuth.validateAccessCode(accessCode);
                    if (result.success) {
                        console.log('Access code verified.');
                        window.gameAuth.setAuth(result.authToken, result.user);
                        this.readText('Access code verified!');
                        this.continueReading();
                        this.readText('Thank you for supporting the project!');
                        this.finishReading();
                        this.darkenScreen(0.1);
                        this.stateQueue.push(SAVE_FILE_SELECT);
                    } else {
                        console.log('Invalid access code.');
                        this.readText('Invalid access code.');
                        this.continueReading();
                        this.readText(`Please try again.`);
                        this.finishReading();
                        this.darkenScreen(0.1);
                        this.stateQueue.push(SET_ACCESS_CODE);
                    }
                });
                break;
            case NEW_FILE_STARTED:
                this.undarkenScreen(0.01);
                this.readText('Hello!');
                this.continueReading();
                this.readText(`Welcome to PKMNG!`);
                this.continueReading();
                this.script(() => this.stateQueue.push(SELECT_PLAYER_GENDER));
                break;
            case SELECT_PLAYER_GENDER:
                this.readText(`Are you a boy or girl?`);
                this.menuHandler.handlePlayerGenderMenu();
                this.readText(() => `Oh so you are a ${this.player.getGender()}? Very cool!`);
                this.finishReading();
                this.script(() => {
                    this.stateQueue.push(SET_PLAYER_NAME);
                });

                // this.readText(
                //     'This is my recreation of Gen 3 style pokemon, powered entirely by Javascript.'
                // );
                // this.continueReading();
                // this.readText('Pretty neat huh?');
                // this.continueReading();
                // this.readText(
                //     'Despite over 18 months of development, this game is still a bit rough around the edges.'
                // );
                // this.continueReading();
                // this.readText(
                //     'After all... I have a full-time job and a life outside of making this game for you.'
                // );
                // this.continueReading();
                // this.readText('But please inform me about the bugs you will inevitably find.');
                // this.continueReading();
                // this.readText('The bug-reports channel or the beta-testing-chat channel will do.');
                // this.continueReading();
                // this.readText('Anyways, enough yapping.');
                // this.continueReading();
                // this.readText('Here are the game controls in case you’re playing with a keyboard.');
                // this.continueReading();
                // this.readText('WASD for motion');
                // this.continueReading();
                // this.readText('The “L” key is the A button');
                // this.continueReading();
                // this.readText('The “K” key is the B button');
                // this.continueReading();
                // this.readText('The “Enter” key is the SELECT button');
                // this.continueReading();
                // this.readText('The “Space” bar is the START button');
                // this.continueReading();
                // this.readText('I hope you got that! I’m not explaining it again.');
                // this.continueReading();
                // this.readText('Oh, and you’re a girl btw. I haven‘t implemented gender selection yet.');
                // this.continueReading();
                // this.readText('You can choose your own name though!');
                // this.continueReading();
                // this.readText('Tell me what it is and we can get you started!');
                // this.finishReading();
                this.darkenScreen(0.05);
                break;
            case USE_KEYBOARD:
                this.menuHandler.handleKeyboardMenu({
                    targetType: 'player',
                    targetDisplayText: 'What is your name?',
                });
                break;
            case SET_NICKNAME:
                this.stateQueue.push(POKEMON);
                this.menuHandler.handleKeyboardMenu({
                    cancelOnEmpty: true,
                    targetType: 'pokemon',
                    targetDisplayText: 'Choose a nickname.',
                    defaultText:
                        this.player.party[this.GUI.pokemonMenu.currentOption].nickname ===
                        this.player.party[this.GUI.pokemonMenu.currentOption].name
                            ? ''
                            : this.player.party[this.GUI.pokemonMenu.currentOption].nickname,
                });
                this.script(() => {
                    this.player.party[this.GUI.pokemonMenu.currentOption].nickname =
                        this.keyboardMenu.output === ''
                            ? this.player.party[this.GUI.pokemonMenu.currentOption].name
                            : this.keyboardMenu.output;
                });
                break;
            case SET_PLAYER_NAME:
                this.script(() => {
                    this.keyboardMenu.targetDisplayText = 'What is your name?';
                });
                this.menuHandler.handleKeyboardMenu({
                    targetDisplayText: 'What is your name?',
                    targetType: 'player',
                });
                this.script(() => {
                    if (this.keyboardMenu.output.trim() === '') {
                        this.stateQueue.push(SET_PLAYER_NAME);
                        return;
                    }
                    this.player.name = this.keyboardMenu.output === '' ? 'Trainer' : this.keyboardMenu.output;
                });
                this.script(() => {
                    if (this.player.name !== '') {
                        this.stateQueue = [IDLE];
                    }
                });
                break;
            case IDLE:
                this.undarkenScreen();
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {},
                        action: () => {
                            this.player.running = false;

                            // After a cut/rock_smash battle, clear the obstacle
                            if (this.context.pendingHMTree) {
                                this.context.pendingHMTree.interact();
                                if (!this.context.pendingHMTree.canInteract()) {
                                    this.context.pendingHMTree = null;
                                    this.context.currentTree = null;
                                }
                                return false;
                            }
                            if (this.context.pendingHMRock) {
                                this.context.pendingHMRock.interact();
                                if (!this.context.pendingHMRock.canInteract()) {
                                    this.context.pendingHMRock = null;
                                    this.context.currentRock = null;
                                }
                                return false;
                            }

                            if (isInteracting()) {
                                return true;
                            }

                            if (
                                this.currentMap.needsFlash &&
                                !this.currentMap.flashWasAttempted
                                // !this.currentMap.checkedForFlashOnCurrentVisit
                            ) {
                                this.stateQueue.push(USE_FLASH);
                            }

                            if (KPI___) {
                                this.stateQueue.push(PAUSE_MENU);
                                return true;
                            }

                            if (this.checkZoneInteractions()) {
                                return true;
                            }

                            return (
                                !this.isTransitioning &&
                                (this.awaitMotionInput() || this.stateQueue.length > 0)
                            );
                        },
                    })
                );
                break;
            case WARP_TO_LOCATION:
                this.darkenScreen();
                this.script(() => {
                    this.moving = false;
                    this.warpToLocation(this.context.currentWarpZone);
                });
                this.undarkenScreen();
                break;
            case CHANGE_DIRECTION:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            // Update sprite
                            this.player.direction = this.player.requestedDirection;
                            return true;
                        },
                    })
                );
                break;
            case START_MOVING:
                break;
            case MOVE_N_STEPS:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.resetCollisions();
                            this.updateCollisions();
                            this.movementSpeed = 1;
                        },
                        action: () => {},
                    })
                );
                break;
            case MOVING:
                this.actions.push(this.createMovingAction());
                break;
            case END_MOVING:
                isInteracting();
                break;
            case READ_TEXT_SOURCE: {
                const textSourceObject = this.adjacentObjects[this.player.direction];
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.cursor = 0;
                            this.overworldText = textSourceObject?.text;
                            if (textSourceObject instanceof NPC) {
                                this.overworldTextSpeaker = textSourceObject.name || '';
                            }
                            if (this.GUI && this.GUI.overworldText) {
                                this.GUI.overworldText.resetToOriginalPosition();
                            }
                        },
                        action: () => {
                            return this.cursor >= this.overworldText.length;
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.cursor = this.overworldText.length;
                            return KPI_L || KPI_K;
                        },
                        endAction: () => {
                            if (this.GUI && this.GUI.overworldText) {
                                this.GUI.overworldText.resetToOriginalPosition();
                            }
                            this.overworldText = '';
                            this.overworldTextSpeaker = '';
                            textSourceObject?.endInteraction();
                        },
                    })
                );
                break;
            }
            case BOOT_UP_PC:
                this.script(() => {
                    this.context.currentPC.bootUp();
                    if (this.pcMenu.partyList.every((pokemon) => pokemon === null)) {
                        for (let i = 0; i < this.player.party.length; i++) {
                            this.pcMenu.partyList[i] = this.player.party[i];
                        }
                    }
                });
                this.readText(`${this.player.name} booted up the PC.`);
                this.continueReading();
                this.readText('Pokemon Storage System opened.');
                this.finishReading();
                this.darkenScreen();
                break;
            case MANAGE_POKEMON:
                this.undarkenScreen();
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.shouldCancel = false;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            return this.awaitPokemonManagementInput();
                        },
                    })
                );
                break;
            case CANT_LEAVE_PC_WITHOUT_POKEMON:
                this.readText('Can’t leave without Pokémon!');
                this.finishReading();
                break;
            case MANAGE_POKEMON_WITH_SELECTED:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            return this.awaitPokemonManagementInput();
                        },
                        endAction: () => {
                            if (this.shouldCancel) {
                                const originalSection = this.pcMenu.selectedPokemonOriginalPosition.section;
                                const originalBox = this.pcMenu.selectedPokemonOriginalPosition.box;
                                const originalRow = this.pcMenu.selectedPokemonOriginalPosition.row;
                                const originalColumn = this.pcMenu.selectedPokemonOriginalPosition.column;
                                if (originalSection === 1) {
                                    // If pokemon was originally in a box, put it back
                                    this.player.pcPokemon[originalBox][originalRow][originalColumn] =
                                        this.pcMenu.selectedPokemon;
                                } else if (originalSection === 2) {
                                    // If pokemon was in your party
                                    this.pcMenu.partyList[originalColumn] = this.pcMenu.selectedPokemon;
                                }

                                // Clear the selection
                                this.pcMenu.selectedPokemon = null;
                            } else if (this.pcMenu.currentPokemon instanceof Pokemon) {
                                // If we are hovering over another pokemon, swap it
                                if (this.pcMenu.currentSection === 1) {
                                    // Swapping with a box pokemon
                                    this.pcMenu.swapBufferPokemon = this.pcMenu.selectedPokemon;
                                    this.pcMenu.selectedPokemon =
                                        this.player.pcPokemon[this.pcMenu.box][this.pcMenu.row][
                                            this.pcMenu.column
                                        ];
                                    this.player.pcPokemon[this.pcMenu.box][this.pcMenu.row][
                                        this.pcMenu.column
                                    ] = this.pcMenu.swapBufferPokemon;
                                } else if (this.pcMenu.currentSection === 2) {
                                    // Swapping with a party pokemon
                                    console.log(this.pcMenu.selectedPokemon.name);
                                    console.log(this.pcMenu.partyList[this.pcMenu.column].name);
                                    console.log('--');
                                    this.pcMenu.swapBufferPokemon = this.pcMenu.selectedPokemon;
                                    this.pcMenu.selectedPokemon = this.pcMenu.partyList[this.pcMenu.column];
                                    this.pcMenu.partyList[this.pcMenu.column] = this.pcMenu.swapBufferPokemon;
                                    console.log(this.pcMenu.selectedPokemon.name);
                                    console.log(this.pcMenu.partyList[this.pcMenu.column].name);
                                    // deugger;
                                } else {
                                    // Swapping with the box title? Nothing should happen here
                                    console.warn('What the heck');
                                }
                            } else {
                                // If we are hovering over an empty slot, place it
                                if (this.pcMenu.currentSection === 1) {
                                    // Placing a pokemon in empty slot in box
                                    this.player.pcPokemon[this.pcMenu.box][this.pcMenu.row][
                                        this.pcMenu.column
                                    ] = this.pcMenu.selectedPokemon;
                                } else if (this.pcMenu.currentSection === 2) {
                                    // Placing a pokemon in empty slot in party
                                    this.pcMenu.partyList[this.pcMenu.column] = this.pcMenu.selectedPokemon;
                                } else {
                                    // Swapping with the box title? nothing should happen here
                                    console.warn('What the heck');
                                }
                                this.pcMenu.selectedPokemon = null;
                                this.pcMenu.selectedPokemonOriginalPosition = {
                                    box: null,
                                    column: null,
                                    row: null,
                                    section: null,
                                };
                            }
                        },
                    })
                );
                break;
            case PC_POKEMON_PRESELECTED:
                // If no pokemon selected
                //      select it
                //      go back to MANAGE_POKEMON
                // else
                //      if new position is empty
                //          place in new position
                //          go back to MANAGE_POKEMON
                //      else
                //          swap with pokemon currently in position

                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.shouldCancel = false;
                            // this.pcMenu.preselectionOption = 0;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pcMenu.preselectionOption = this.awaitVerticalOptionInput(
                                this.pcMenu.preselectionOption,
                                this.pcMenu.preselectionOptions.length
                            ).currentOption;

                            return this.awaitVerticalOptionInput(
                                this.pcMenu.preselectionOption,
                                this.pcMenu.preselectionOptions.length
                            ).selected;
                        },
                        endAction: () => {
                            if (this.shouldCancel) {
                                return;
                            }

                            const selectedOption = this.pcMenu.preselectionOption;

                            if (selectedOption === 0) {
                                // Move
                                if (this.pcMenu.currentSection === 1) {
                                    // If we are in the box section
                                    // Update the selected pokemon
                                    this.pcMenu.selectedPokemon = this.pcMenu.currentPokemon;
                                    // Save the original box position of the pokemon you selected
                                    // in case we cancel and have to return it back to its original
                                    // position
                                    this.pcMenu.selectedPokemonOriginalPosition = {
                                        section: this.pcMenu.currentSection,
                                        box: this.pcMenu.box,
                                        row: this.pcMenu.row,
                                        column: this.pcMenu.column,
                                    };
                                    // Mark the position of the selected pokemon as null
                                    this.player.pcPokemon[this.pcMenu.box][this.pcMenu.row][
                                        this.pcMenu.column
                                    ] = null;
                                } else if (this.pcMenu.currentSection === 2) {
                                    // If we are in the party section
                                    // Update the selected pokemon
                                    this.pcMenu.selectedPokemon = this.pcMenu.currentPokemon;
                                    // Save the original box position, same reason as above
                                    this.pcMenu.selectedPokemonOriginalPosition = {
                                        section: this.pcMenu.currentSection,
                                        box: this.pcMenu.box,
                                        column: this.pcMenu.column,
                                    };
                                    // Mark the position of the selected pokemon as null in the party list,
                                    // not in the player's actual party.
                                    this.pcMenu.partyList[this.pcMenu.column] = null;
                                }
                            } else if (selectedOption === 1) {
                                // Summary
                                this.stateQueue.push(POKEMON_SUMMARY);
                            } else if (selectedOption === 2) {
                                // Release
                                this.stateQueue.push(RELEASE_POKEMON);
                            }
                        },
                    })
                );
                break;
            case RELEASE_POKEMON:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            return this.GUI.pcMenu.currentIcon().shrink();
                        },
                    })
                );
                this.readText(`${this.pcMenu.currentPokemon.name} was released.`);
                this.continueReading();
                this.readText(`Bye bye, ${this.pcMenu.currentPokemon.name}!`);
                this.finishReading();
                this.script(() => {
                    if (this.pcMenu.currentSection === 1) {
                        this.player.pcPokemon[this.pcMenu.box][this.pcMenu.row][this.pcMenu.column] = null;
                        this.GUI.pcMenu.boxIcons[this.pcMenu.row][this.pcMenu.column] = null;
                    } else if (this.pcMenu.currentSection === 2) {
                        this.pcMenu.partyList[this.pcMenu.column] = null;
                        this.GUI.pcMenu.partyIcons[this.pcMenu.column] = null;
                    }
                });
                break;
            case SHUT_DOWN_PC:
                this.darkenScreen();
                this.script(() => {
                    this.context.currentPC.active = false;
                    this.player.party = this.pcMenu.partyList.filter((p) => p !== null);
                    this.pcMenu.partyList = [null, null, null, null, null, null];
                    this.pcMenu.currentPokemon = null;
                    this.pcMenu.selectedPokemon = null;
                    this.pcMenu.swapBufferPokemon = null;
                });
                break;
            case INTERACT_WITH_MART_LOCATION:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            const martLocation = this.adjacentObjects[this.player.direction];
                            const clerk = martLocation.clerk;
                            clerk.direction = martLocation.clerkDirection;
                            return true;
                        },
                    })
                );
                this.readTextAndWait(this.adjacentObjects[this.player.direction]?.preInteractionText);
                break;
            case CHOOSE_MART_OPTION:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            // this.overworldText = this.adjacentObjects[this.player.direction]?.preInteractionText;
                            this.cursor = this.overworldText.length;
                        },
                        action: () => {
                            this.cursor = this.overworldText.length;
                            // Open mart menu
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            // Press k to cancel
                            if (KPI_K) {
                                this.shouldCancel = true;
                                return true;
                            }

                            this.martMenuOption = this.awaitVerticalOptionInput(
                                this.martMenuOption,
                                3 // Buy, Sell, See Ya!
                            ).currentOption;
                            return this.awaitVerticalOptionInput(this.martMenuOption, 3).selected;
                        },
                    })
                );
                break;
            case BUY_FROM_MART:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.overworldText = '';
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.currentMartInventory =
                                this.adjacentObjects[this.player.direction]?.inventory;
                            this.martItemOption = this.awaitVerticalOptionInput(
                                this.martItemOption,
                                this.currentMartInventory.length
                            ).currentOption;

                            return this.awaitVerticalOptionInput(
                                this.martItemOption,
                                this.currentMartInventory.length
                            ).selected;
                        },
                    })
                );
                break;
            case MART_OPTION_PRESELECTED:
                this.readText(
                    `Certainly! How many ${
                        globalItemDataStore[this.currentMartInventory[this.martItemOption].itemId]?.name
                    }s would you like?`
                );
                this.autoContinueReading();
                break;
            case MART_OPTION_SELECT_AMOUNT:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.martItemAmount = 1;
                        },
                        action: () => {
                            this.cursor = this.overworldText.length;
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }

                            this.martItemAmount = this.awaitVerticalOptionInput(
                                this.martItemAmount,
                                101,
                                true
                            ).currentOption;

                            if (this.martItemAmount === 0) {
                                this.martItemAmount = 99;
                            }
                            if (this.martItemAmount === 100) {
                                this.martItemAmount = 1;
                            }

                            this.martCurrentCost =
                                this.martItemAmount * this.currentMartInventory[this.martItemOption].cost;

                            return this.awaitVerticalOptionInput(this.martItemAmount, 101).selected;
                        },
                    })
                );
                break;
            case MART_NOT_ENOUGH_MONEY:
                this.readText(`You don't have enough money for that!`);
                this.continueReading();
                break;
            case MART_ITEM_AMOUNT_SELECTED:
                this.readText(
                    `For ${this.martItemAmount} ${
                        globalItemDataStore[this.currentMartInventory[this.martItemOption].itemId]?.name
                    }${this.martItemAmount === 1 ? '' : 's'} the total cost will be \u20BD${
                        this.martCurrentCost
                    }. Is that ok?`
                );
                this.autoContinueReading();
                this.askYesOrNo(false);
                break;
            case MART_ITEM_AMOUNT_CONFIRMED:
                this.readText(' ');
                this.autoContinueReading();
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.overworldText = ' ';
                            this.cursor = 1;
                            if (this.martItemAmount > 0) {
                                this.player.acquireItemFromId(
                                    this.currentMartInventory[this.martItemOption].itemId
                                );
                                this.martItemAmount -= 1;
                            }
                            return this.martItemAmount === 0;
                        },
                        endAction: () => {
                            this.player.money -= this.martCurrentCost;
                        },
                    })
                );
                this.readText('Here you go! Thanks so much!');
                this.continueReading();
                break;
            case MART_ANYTHING_ELSE:
                this.readText('Can I help you with anything else?');
                this.autoContinueReading();
                break;
            case SELL_TO_MART:
                this.bagMenu.update();
                this.menuHandler.handleBagMenuSell(this);
                break;
            case CANT_SELL_THIS_ITEM:
                this.readText('This item can’t be sold!');
                this.finishReading();
                this.stateQueue.push(SELL_TO_MART);
                break;
            case MART_SELL_AMOUNT:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.martItemAmount = 1;
                            this.martCurrentCost = Math.round(
                                this.martItemAmount * this.selectedItem.price * 0.5
                            );
                            return true;
                        },
                    })
                );
                this.readText(`How many ${this.selectedItem.name}s would you like to sell?`);
                this.autoContinueReading();
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.martItemAmount = 1;
                        },
                        action: () => {
                            this.cursor = this.overworldText.length;
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }

                            const maxSellableAmount = this.player.itemCount(this.selectedItem.id);

                            this.martItemAmount = this.awaitVerticalOptionInput(
                                this.martItemAmount,
                                maxSellableAmount + 2,
                                true
                            ).currentOption;

                            if (this.martItemAmount === 0) {
                                this.martItemAmount = maxSellableAmount;
                            }
                            if (this.martItemAmount > maxSellableAmount) {
                                this.martItemAmount = 1;
                            }

                            this.martCurrentCost = Math.round(
                                this.martItemAmount * this.selectedItem.price * 0.5
                            );

                            return this.awaitVerticalOptionInput(this.martItemAmount, maxSellableAmount + 2)
                                .selected;
                        },
                    })
                );
                break;
            case MART_SELL_AMOUNT_CONFIRMATION:
                this.readText(
                    `Are you sure you want to sell ${this.martItemAmount} ${this.selectedItem.name}${
                        this.martItemAmount === 1 ? '' : 's'
                    } for \u20BD${this.martCurrentCost}?`
                );
                this.autoContinueReading();
                this.askYesOrNo(false);
                break;
            case MART_ITEMS_SOLD:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.martItemAmount > 0) {
                                this.player.useItemV2(this.selectedItem.id);
                                this.martItemAmount -= 1;
                            }
                            return this.martItemAmount === 0;
                        },
                        endAction: () => {
                            this.player.money += this.martCurrentCost;
                            this.martCurrentCost = 0;
                            this.martItemAmount = 0;
                            this.selectedItem = null;
                        },
                    })
                );
                this.readText(
                    `You sold ${this.martItemAmount} ${this.selectedItem.name}${
                        this.martItemAmount === 1 ? '' : 's'
                    } for \u20BD${this.martCurrentCost}!`
                );
                this.finishReading();
                break;
            case END_MART_INTERACTION:
                this.martMenuOption = 0;
                this.readText('We hope to see you again!');
                this.finishReading();
                break;
            case INTERACT_WITH_HEALING_LOCATION:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.currentHealingLocation = this.adjacentObjects[this.player.direction];
                            this.overworldText = this.currentHealingLocation?.preInteractionText;
                            this.overworldTextSpeaker = this.currentHealingLocation?.nurse?.name || '';
                        },
                        action: () => {
                            return this.cursor >= this.overworldText.length;
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.cursor = this.overworldText.length;
                            return KPI_L || KPI_K;
                        },
                        endAction: () => {
                            this.overworldText = '';
                            this.overworldTextSpeaker = '';
                            this.adjacentObjects[this.player.direction]?.endInteraction();
                        },
                    })
                );
                this.script(() => {
                    this.currentHealingLocation.nurse.direction = 'left';
                });
                this.script(() => {
                    this.currentHealingLocation.showOnePokeball();
                });
                this.delay(30);
                if (this.player.party.length >= 2) {
                    this.script(() => {
                        this.currentHealingLocation.showTwoPokeballs();
                    });
                    this.delay(30);
                }

                if (this.player.party.length >= 3) {
                    this.script(() => {
                        this.currentHealingLocation.showThreePokeballs();
                    });
                    this.delay(30);
                }

                if (this.player.party.length >= 4) {
                    this.script(() => {
                        this.currentHealingLocation.showFourPokeballs();
                    });
                    this.delay(30);
                }

                if (this.player.party.length >= 5) {
                    this.script(() => {
                        this.currentHealingLocation.showFivePokeballs();
                    });
                    this.delay(30);
                }

                if (this.player.party.length === 6) {
                    this.script(() => {
                        this.currentHealingLocation.showSixPokeballs();
                    });
                    this.delay(30);
                }

                this.script(() => {
                    this.currentHealingLocation.animatePokeballs();
                });
                this.delay(150);

                this.script(() => {
                    this.currentHealingLocation.resetPokeballs();
                });
                this.script(() => {
                    this.currentHealingLocation.nurse.direction = 'down';
                });

                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.player.healParty();
                        },
                        action: () => {
                            return this.player.isPartyHealed();
                        },
                        endAction: () => {},
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.overworldText =
                                this.adjacentObjects[this.player.direction]?.postInteractionText;
                            this.overworldTextSpeaker = this.currentHealingLocation?.nurse?.name || '';
                        },
                        action: () => {
                            return this.cursor >= this.overworldText.length;
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.cursor = this.overworldText.length;
                            return KPI_L || KPI_K;
                        },
                        endAction: () => {
                            this.overworldText = '';
                            this.overworldTextSpeaker = '';
                            this.adjacentObjects[this.player.direction]?.endInteraction();
                        },
                    })
                );

                break;
            case INTERACT_WITH_NPC:
                this.script(() => {
                    this.activeNPC.interact();
                });
                break;
            case INTERACT_WITH_STATIC_ENCOUNTER:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            // Check if pokemon is ready, if not wait
                            const staticEncounter = this.context.currentStaticEncounter;
                            if (!staticEncounter.pokemonInstance) {
                                // Pokemon not ready yet, keep waiting
                                staticEncounter.pokemonPromise.then(() => {
                                    // This will be handled on next frame
                                });
                                return false;
                            }
                            // Pokemon is ready, proceed
                            this.context.upcomingBattleOptions = {
                                pokemon: staticEncounter.pokemonInstance,
                                isStaticEncounter: true,
                            };
                            return true;
                        },
                    })
                );
                // this.context.currentStaticEncounter.visible = false;
                // this.context.currentStaticEncounter.position.z = 7;
                this.stateQueue.push(START_BATTLE);
                break;

            case INTERACT_WITH_HM_TREE: {
                this.readText('This tree can be cut down...');
                this.continueReading();
                if (!this.player.hasCut()) {
                    this.finishReading();
                } else {
                    this.readText(`${this.player.name} used Cut!`);
                    this.finishReading();
                    let hmTreeRolled = false;
                    this.actions.push(
                        new OverworldAction({
                            action: () => {
                                if (!hmTreeRolled) {
                                    hmTreeRolled = true;
                                    const rate = this.currentLocation?.encounterRateCut ?? 1.0;
                                    const hasCutEncounters =
                                        this.currentLocation?.getAvailableCutPokemon()?.length > 0;
                                    if (
                                        hasCutEncounters &&
                                        !this.shouldSkipWildBattles() &&
                                        Math.random() < rate
                                    ) {
                                        this.context.upcomingBattleOptions = {
                                            encounterType: 'cut',
                                        };
                                        this.context.pendingHMTree = this.context.currentTree;
                                        this.stateQueue.push(START_BATTLE);
                                        return true;
                                    }
                                }
                                this.context.currentTree.interact();
                                return !this.context.currentTree.canInteract();
                            },
                            endAction: () => {
                                if (!this.context.pendingHMTree) {
                                    this.context.currentTree = null;
                                }
                            },
                        })
                    );
                }
                break;
            }
            case INTERACT_WITH_HM_ROCK: {
                this.readText('It seems this rock can be smashed out of the way...');
                this.continueReading();
                if (this.player.hasRockSmash()) {
                    this.readText(`${this.player.name} used Rock Smash!`);
                    this.finishReading();
                    let hmRockRolled = false;
                    this.actions.push(
                        new OverworldAction({
                            action: () => {
                                if (!hmRockRolled) {
                                    hmRockRolled = true;
                                    const rate = this.currentLocation?.encounterRateRockSmash ?? 1.0;
                                    const hasRockSmashEncounters =
                                        this.currentLocation?.getAvailableRockSmashPokemon()?.length > 0;
                                    if (
                                        hasRockSmashEncounters &&
                                        !this.shouldSkipWildBattles() &&
                                        Math.random() < rate
                                    ) {
                                        this.context.upcomingBattleOptions = {
                                            encounterType: 'rock_smash',
                                        };
                                        this.context.pendingHMRock = this.context.currentRock;
                                        this.stateQueue.push(START_BATTLE);
                                        return true;
                                    }
                                }
                                this.context.currentRock.interact();
                                return !this.context.currentRock.canInteract();
                            },
                            endAction: () => {
                                if (!this.context.pendingHMRock) {
                                    this.context.currentRock = null;
                                }
                            },
                        })
                    );
                } else {
                    this.finishReading();
                }
                break;
            }
            case ACQUIRE_OVERWORLD_ITEM:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            const acquiredItem = this.adjacentObjects[this.player.direction];
                            acquiredItem.acquired = true;
                            acquiredItem.visible = false;
                            this.player.acquireItem(acquiredItem.item);
                            this.overworldText = `${this.player.name} found a ${acquiredItem.item.name}!`;
                        },
                        action: () => {
                            return this.cursor >= this.overworldText.length;
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.cursor = this.overworldText.length;
                            return KPI_L || KPI_K;
                        },
                        endAction: () => {
                            this.overworldText = '';
                            this.adjacentObjects[this.player.direction]?.endInteraction();
                        },
                    })
                );
                break;
            case COLLISION:
                isInteracting();
                break;
            case START_BATTLE:
                this.script(() => {
                    this.moving = false;
                    this.justBattled = true;
                });

                this.darkenScreen();
                this.undarkenScreen();
                this.darkenScreen();
                this.undarkenScreen();
                this.darkenScreen();
                this.undarkenScreen();
                this.darkenScreen();
                this.activateBattle(this.context.upcomingBattleOptions);
                this.undarkenScreen();
                break;
            case START_TRAINER_BATTLE:
                this.script(() => {
                    this.trainerBattleHistory.unshift(this.context.npcSeenBy);
                });
                this.stateQueue.push(START_BATTLE);
                break;
            case BATTLE:
                break;
            case END_BATTLE:
                break;
            case EVOLVE_POKEMON:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.context.recentlyEvolvedPokemon = this.player.party.filter((pokemon) =>
                                pokemon.checkCanEvolveViaLevelUp()
                            )[0];
                        },
                        action: () => {
                            this.player.moving = false;
                            this.overworldText = `Wow! ${this.context.recentlyEvolvedPokemon.name} evolved into ${this.context.recentlyEvolvedPokemon.evolutionName}!`;
                            return true;
                        },
                    })
                );
                this.finishReading();
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.context.recentlyEvolvedPokemon.evolve();
                            return true;
                        },
                        endAction: () => {
                            this.context.recentlyEvolvedPokemon = null;
                        },
                    })
                );
                this.script(() => {
                    if (this.player.party[this.pokemonOption].hasNewMoveAvailable()) {
                        this.context.currentPokemon = this.player.party[this.pokemonOption];
                        this.context.learnedMoveState = BAG;
                        this.context.currentMove =
                            this.player.party[this.pokemonOption].getNextLearnableMoveForCurrentLevel();
                    }
                });
                break;
            case PAUSE_MENU:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput() || KPI___) {
                                this.shouldCancel = true;
                                return true;
                            }
                            return this.pauseMenu.manageInputs();
                        },
                    })
                );
                break;
            case OPTIONS_MENU:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput() || KPI_K) {
                                this.shouldCancel = true;
                                return true;
                            }
                            return this.optionsMenu.manageInputs();
                        },
                    })
                );
                break;
            case POKEDEX:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.GUI.pokedexMenu.refreshPokedex();
                            this.context.pokedexMenuDebounce = 0;
                            // Add these to track initial press state
                            this.context.initialPress = {
                                up: false,
                                down: false,
                            };
                            this.context.holdFrames = 0;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                            }

                            const INITIAL_HOLD_FRAMES = 30; // 0.5 seconds at 60fps
                            const SCROLL_DELAY = 1; // Normal scroll speed after initial delay

                            // Handle up movement
                            if (keys.w.pressed || keys.W.pressed) {
                                if (!this.context.initialPress.up) {
                                    // First press - move immediately
                                    if (this.pokedexMenuOption > 0) {
                                        this.pokedexMenuOption -= 1;
                                    }
                                    this.context.initialPress.up = true;
                                    this.context.holdFrames = 0;
                                } else {
                                    // Holding the button
                                    this.context.holdFrames++;
                                    if (this.context.holdFrames >= INITIAL_HOLD_FRAMES) {
                                        // After delay, use normal scroll speed
                                        if (
                                            this.pokedexMenuOption > 0 &&
                                            this.context.pokedexMenuDebounce < 0
                                        ) {
                                            this.pokedexMenuOption -= 1;
                                            this.context.pokedexMenuDebounce = SCROLL_DELAY;
                                        }
                                    }
                                }
                            } else {
                                this.context.initialPress.up = false;
                            }

                            // Handle down movement
                            if (keys.s.pressed || keys.S.pressed) {
                                if (!this.context.initialPress.down) {
                                    // First press - move immediately
                                    const maxPokemonCount = this.GUI.pokedexMenu.getMaxPokemonCount() - 1; // -1 because option is 0-indexed
                                    if (this.pokedexMenuOption < maxPokemonCount) {
                                        this.pokedexMenuOption += 1;
                                    }
                                    this.context.initialPress.down = true;
                                    this.context.holdFrames = 0;
                                } else {
                                    // Holding the button
                                    this.context.holdFrames++;
                                    if (this.context.holdFrames >= INITIAL_HOLD_FRAMES) {
                                        // After delay, use normal scroll speed
                                        const maxPokemonCount = this.GUI.pokedexMenu.getMaxPokemonCount() - 1; // -1 because option is 0-indexed
                                        if (
                                            this.pokedexMenuOption < maxPokemonCount &&
                                            this.context.pokedexMenuDebounce < 0
                                        ) {
                                            this.pokedexMenuOption += 1;
                                            this.context.pokedexMenuDebounce = SCROLL_DELAY;
                                        }
                                    }
                                }
                            } else {
                                this.context.initialPress.down = false;
                            }

                            this.context.pokedexMenuDebounce -= 1;
                            return this.shouldCancel || KPI_L;
                        },
                    })
                );
                break;
            case TRAINER_CARD:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                        },
                    })
                );
                break;
            case POKEMON:
                this.undarkenScreen();
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonOption = this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length + 1
                            ).currentOption;
                            return this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length + 1
                            ).selected;
                        },
                    })
                );
                break;
            case SWITCH_POSITIONS_WITH_WHO:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.context.pokemonSwitchIndex1 = this.pokemonOption;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonOption = this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length
                            ).currentOption;
                            return this.awaitPokemonOptionInput(this.pokemonOption, this.player.party.length)
                                .selected;
                        },
                        endAction: () => {
                            this.context.pokemonSwitchIndex2 = this.pokemonOption;
                        },
                    })
                );
                break;
            case POKEMON_SWITCH_POSITIONS:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            return this.GUI.darken();
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            const temp = this.player.party[this.context.pokemonSwitchIndex1]; // Hold the first element in a temporary variable
                            this.player.party[this.context.pokemonSwitchIndex1] =
                                this.player.party[this.context.pokemonSwitchIndex2]; // Assign the second element to the first position
                            this.player.party[this.context.pokemonSwitchIndex2] = temp; // Assign the first element from the temporary variable to the second position
                            return true;
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            return this.GUI.undarken();
                        },
                    })
                );
                break;
            case POKEMON_PRESELECTED:
                this.undarkenScreen();
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.shouldCancel = false;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonDetailOption = this.awaitVerticalOptionInput(
                                this.pokemonDetailOption,
                                5
                            ).currentOption;
                            return this.awaitVerticalOptionInput(this.pokemonDetailOption, 5).selected;
                        },
                    })
                );
                this.script(() => {
                    if (this.pokemonDetailOption === 3 && !this.shouldCancel) {
                        this.actions.push(this.darkenScreen());
                    }
                });
                break;
            case DO_WHAT_WITH_ITEM:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.pokemonItemOption = 0;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonItemOption = this.awaitVerticalOptionInput(
                                this.pokemonItemOption,
                                3
                            ).currentOption;
                            return this.awaitVerticalOptionInput(this.pokemonItemOption, 3).selected;
                        },
                    })
                );
                break;
            case POKEMON_SUMMARY:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            // Save all box pokemon's box position in order to
                            // correctly update the cursor position after we return
                            // from the summary
                            if (this.previousState === MANAGE_POKEMON) {
                                this.summaryPokemonList = [];
                                this.pcBoxPokemonSummaryOption = 0;
                                this.pcPartyPokemonSummaryOption = 0;
                                // Figure out the correct initial index in the summaryPokemonList
                                // Figure out index as if all positions were full
                                // Populate list
                                let nullCountBeforeMaxCurrentIndex = 0;
                                if (this.pcMenu.currentSection === 1) {
                                    const maxCurrentIndex = this.pcMenu.row * 6 + this.pcMenu.column;
                                    this.player.pcPokemon[this.pcMenu.box].forEach((row, i) => {
                                        row.forEach((pokemon, j) => {
                                            if (
                                                i * 6 + j < this.pcMenu.row * 6 + this.pcMenu.column &&
                                                pokemon === null
                                            ) {
                                                nullCountBeforeMaxCurrentIndex += 1;
                                            }
                                            if (pokemon instanceof Pokemon) {
                                                pokemon.currentBoxLocation = {};
                                                pokemon.currentBoxLocation = {
                                                    row: i,
                                                    column: j,
                                                    section: 1,
                                                };
                                                this.summaryPokemonList.push(pokemon);
                                            }
                                        });
                                    });
                                    this.pcBoxPokemonSummaryOption =
                                        maxCurrentIndex - nullCountBeforeMaxCurrentIndex;
                                } else if (this.pcMenu.currentSection === 2) {
                                    const maxCurrentIndex = this.pcMenu.column;
                                    this.pcMenu.partyList.forEach((pokemon, i) => {
                                        if (i <= this.pcMenu.column && pokemon === null) {
                                            nullCountBeforeMaxCurrentIndex += 1;
                                        }
                                        if (pokemon instanceof Pokemon) {
                                            pokemon.currentBoxLocation = {
                                                row: 3,
                                                column: i,
                                                section: 2,
                                            };
                                            this.summaryPokemonList.push(pokemon);
                                        }
                                    });
                                    // this.summaryPokemonList = this.pcMenu.partyList;
                                    this.pcBoxPokemonSummaryOption =
                                        maxCurrentIndex - nullCountBeforeMaxCurrentIndex;
                                }
                            } else if (this.previousState === POKEMON_PRESELECTED) {
                                this.summaryPokemonList = this.player.party;
                            }
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                if (this.currentSummaryPokemon.currentBoxLocation) {
                                    this.pcMenu.currentSection =
                                        this.currentSummaryPokemon.currentBoxLocation.section;
                                    this.pcMenu.row = this.currentSummaryPokemon.currentBoxLocation.row;
                                    this.pcMenu.column = this.currentSummaryPokemon.currentBoxLocation.column;
                                }
                                this.goToPreviousState();
                                return true;
                            }
                            if (this.previousState === POKEMON_PRESELECTED) {
                                this.pokemonOption = this.awaitVerticalOptionInput(
                                    this.pokemonOption,
                                    this.player.party.length
                                ).currentOption;
                                // this.currentSummaryPokemon = this.player.party[this.pokemonOption];
                                this.currentSummaryPokemon = this.summaryPokemonList[this.pokemonOption];
                            } else if (this.previousState === MANAGE_POKEMON) {
                                this.pcBoxPokemonSummaryOption = this.awaitVerticalOptionInput(
                                    this.pcBoxPokemonSummaryOption,
                                    this.summaryPokemonList.length
                                ).currentOption;
                                this.currentSummaryPokemon =
                                    this.summaryPokemonList[this.pcBoxPokemonSummaryOption];

                                // this.pcMenu.currentSection = this.currentSummaryPokemon.section;
                                if (
                                    this.currentSummaryPokemon.currentBoxLocation.section !== null ||
                                    this.currentSummaryPokemon.currentBoxLocation.section !== undefined
                                ) {
                                    this.pcMenu.currentSection =
                                        this.currentSummaryPokemon.currentBoxLocation.section;
                                }
                                if (
                                    this.currentSummaryPokemon.currentBoxLocation.column !== null ||
                                    this.currentSummaryPokemon.currentBoxLocation.column !== undefined
                                ) {
                                    this.pcMenu.column = this.currentSummaryPokemon.currentBoxLocation.column;
                                }
                                if (
                                    this.currentSummaryPokemon.currentBoxLocation.row !== null ||
                                    this.currentSummaryPokemon.currentBoxLocation.row !== undefined
                                ) {
                                    this.pcMenu.row = this.currentSummaryPokemon.currentBoxLocation.row;
                                }
                                if (
                                    this.currentSummaryPokemon !== null ||
                                    this.currentSummaryPokemon !== undefined
                                ) {
                                    this.pcMenu.currentPokemon = this.currentSummaryPokemon;
                                }
                                // PC Menu position needs to be updated
                            }

                            this.summaryOption = this.awaitHorizontalOptionInput(
                                this.summaryOption,
                                3
                            ).currentOption;

                            if (KPI_L) {
                                if (this.summaryOption === 2) {
                                    // If we are in the move page, go to move detail
                                    this.stateQueue.push(POKEMON_MOVE_DETAIL);
                                    return true;
                                }
                            }
                            return false;
                        },
                    })
                );
                break;
            case POKEMON_MOVE_DETAIL:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                this.goToPreviousState();
                                return true;
                            }
                            this.moveDetailOption = this.awaitVerticalOptionInput(
                                this.moveDetailOption,
                                5
                            ).currentOption;
                            return this.awaitVerticalOptionInput(this.moveDetailOption, 5).selected;
                        },
                    })
                );
                break;
            case BAG:
                this.bagMenu.update();
                this.menuHandler.handleBagMenuOverworld(this);
                break;
            case BAG_ITEM_PRESELECTED:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.bagItemDetailOption = this.awaitVerticalOptionInput(
                                this.bagItemDetailOption,
                                this.selectedItem.overworldOptions.length
                            ).currentOption;
                            return this.awaitVerticalOptionInput(
                                this.bagItemDetailOption,
                                this.selectedItem.overworldOptions.length
                            ).selected;
                        },
                        endAction: () => {
                            if (this.shouldCancel) {
                                return true;
                            }
                            if (this.selectedItem instanceof HM) {
                                this.context.currentMove = this.selectedItem.move;
                            }
                        },
                    })
                );
                break;
            case KEY_ITEM_PRESELECTED:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.bagItemDetailOption = this.awaitVerticalOptionInput(
                                this.bagItemDetailOption,
                                this.selectedItem.overworldOptions.length
                            ).currentOption;
                            return this.awaitVerticalOptionInput(
                                this.bagItemDetailOption,
                                this.selectedItem.overworldOptions.length
                            ).selected;
                        },
                    })
                );
                break;
            case USE_KEY_ITEM:
                this.script(() => {
                    this.selectedItem.use();
                });
                break;
            case TOWN_MAP:
                this.script(() => {
                    this.GUI.townMapMenu.setCurrentPosition(
                        this.currentLocation?.townMapPosition ?? null
                    );
                    this.GUI.townMapMenu.buildLocationIndex((locationId) =>
                        Location.get(locationId)
                    );
                });
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            if (KPI_L) {
                                const hovered = this.GUI.townMapMenu.getHoveredLocation();
                                if (hovered) {
                                    this.context.townMapSelectedLocation = hovered;
                                    this.stateQueue.push(TOWN_MAP_LOCATION_DETAIL);
                                    return true;
                                }
                            }
                            this.GUI.townMapMenu.handleCursorInput(keys);
                            return false;
                        },
                    })
                );
                break;
            case TOWN_MAP_LOCATION_DETAIL:
                this.readText(() => {
                    const loc = this.context.townMapSelectedLocation;
                    return `${loc?.name ?? 'This place'}: location details coming soon...`;
                });
                this.finishReading();
                break;
            case CANT_USE_ITEM:
                this.readText('There’s a time and place for everything!');
                this.finishReading();
                break;
            case SELECT_ITEM_RECIPIENT:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonOption = this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length + 1
                            ).currentOption;
                            return this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length + 1
                            ).selected;
                        },
                        endAction: () => {},
                    })
                );
                break;
            case ITEM_GIVEN_TO_POKEMON:
                this.script(() => {
                    if (!this.selectedItem.canBeHeld) {
                        this.overworldText = `${this.selectedItem.name} can't be held.`;
                    } else if (this.player.party[this.pokemonOption].heldItem) {
                        // Take currently held item
                        const currentPokemon = this.player.party[this.pokemonOption];
                        const itemId = currentPokemon.heldItem.id;
                        this.context.acquiredItem = this.player.acquireItemFromId(itemId);

                        // Give new item
                        this.player.party[this.pokemonOption].heldItem = this.selectedItem;
                        this.player.useItemV2(this.selectedItem.id);
                        this.overworldText = `${this.context.acquiredItem.name} was taken and replaced with the ${this.selectedItem.name}.`;
                    } else {
                        // Give item
                        this.player.party[this.pokemonOption].heldItem = this.selectedItem;
                        this.player.useItemV2(this.selectedItem.id);
                        this.overworldText = `${this.selectedItem.name} was given to ${
                            this.player.party[this.pokemonOption].name
                        } to hold.`;
                    }
                });
                this.finishReading();
                break;
            case ITEM_TAKEN_FROM_POKEMON:
                if (this.player.party[this.pokemonOption].heldItem) {
                    const itemId = this.player.party[this.pokemonOption].heldItem.id;
                    this.context.acquiredItem = this.player.acquireItemFromId(itemId);
                    this.script(() => {
                        this.player.party[this.pokemonOption].heldItem = null;
                    });
                    this.readText(
                        `Took ${this.context.acquiredItem.name} from ${
                            this.player.party[this.pokemonOption].name
                        }.`
                    );
                } else {
                    this.readText(`${this.player.party[this.pokemonOption].name} isn't holding anything.`);
                }
                this.finishReading();
                break;
            case SELECT_ITEM_CONSUMER:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonOption = this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length + 1
                            ).currentOption;
                            return this.awaitPokemonOptionInput(
                                this.pokemonOption,
                                this.player.party.length + 1
                            ).selected;
                            // TODO: push to state queue either APPLY_ITEM_TO_RECIPIENT or APPLY_HM_TO_RECIPIENT depending on the selected item
                        },
                    })
                );
                break;
            case SELECT_ITEM_CONSUMER_MOVE:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.overworldText = '';
                            // this.GUI.text.color = 'white'
                            // d.overworldTextBox.visible = false
                            const curPokemonMoves = this.player.party[this.pokemonOption].moves;
                            const m0 = curPokemonMoves[0]?.name ?? '--';
                            const m1 = curPokemonMoves[1]?.name ?? '--';
                            const m2 = curPokemonMoves[2]?.name ?? '--';
                            const m3 = curPokemonMoves[3]?.name ?? '--';
                            d.pokemonMenu.sprites.moveOptionsBox.options = [m0, m1, m2, m3];
                            this.moveItemOption = 0;
                            if (!['elixir', 'max_elixir'].includes(this.selectedItem.id)) {
                                d.pokemonMenu.visible = true;
                                d.pokemonMenu.sprites.moveOptionsBox.visible = true;
                            }
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.pokemonMenuText = 'Use on which move?';
                            const maxOptions = 4;
                            this.moveItemOption = this.awaitPokemonOptionInput(
                                this.moveItemOption,
                                maxOptions
                            ).currentOption;
                            return this.awaitPokemonOptionInput(Math.floor(this.moveItemOption), maxOptions)
                                .selected;
                        },
                        endAction: () => {
                            if (this.shouldCancel) {
                                return;
                            }
                            const selectedMove =
                                this.player.party[this.pokemonOption].moves[this.moveItemOption];
                            if (selectedMove === null || selectedMove === undefined) {
                                this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                                return;
                            }
                            if (['elixir', 'max_elixir'].includes(this.selectedItem.id)) {
                                this.player.party[this.pokemonOption].moves[0]?.applyItem(
                                    this.selectedItem.id
                                );
                                this.player.party[this.pokemonOption].moves[1]?.applyItem(
                                    this.selectedItem.id
                                );
                                this.player.party[this.pokemonOption].moves[2]?.applyItem(
                                    this.selectedItem.id
                                );
                                this.player.party[this.pokemonOption].moves[3]?.applyItem(
                                    this.selectedItem.id
                                );
                                this.player.useItemV2(this.selectedItem.id);
                                return;
                            }
                            if (selectedMove.canApplyItem(this.selectedItem)) {
                                this.player.party[this.pokemonOption].moves[this.moveItemOption].applyItem(
                                    this.selectedItem.id
                                );
                                this.player.useItemV2(this.selectedItem.id);
                                return;
                            } else {
                                this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                            }
                        },
                    })
                );
                break;
            case APPLY_ITEM_TO_MOVE: {
                const isPPVitamin = ['pp_up', 'pp_max'].includes(this.selectedItem?.id);
                this.readText(isPPVitamin ? "The move's PP increased!" : "Move's PP was restored!");
                this.finishReading();
                break;
            }
            case APPLY_ITEM_TO_RECIPIENT:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            const isHealingBerry =
                                berryItemIds.includes(this.selectedItem.id) &&
                                this.selectedItem.healAmount !== null && this.selectedItem.healAmount !== undefined;
                            if (this.selectedItem.isHealingItem() || isHealingBerry) {
                                const pokemonToHeal = this.player.party[this.pokemonOption];
                                const targetHealAmount =
                                    this.selectedItem.id === 'revive'
                                        ? Math.round(pokemonToHeal.stats.maxHp / 2)
                                        : this.selectedItem.healAmount;
                                this.selectedItem.healAmount = targetHealAmount;
                            }
                        },
                        action: () => {
                            if (this.selectedItem.isHM()) {
                                this.context.learnedMoveState = BAG;
                                if (
                                    !this.player.party[this.pokemonOption].canLearnMove(
                                        this.selectedItem.move
                                    )
                                ) {
                                    this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                                    return true;
                                }
                                this.stateQueue.push(APPLY_HM_TO_RECIPIENT);
                                this.overworldText = `Booted up ${this.selectedItem.name}.`;
                                return true;
                            } else {
                                console.log(
                                    'can apply item: ',
                                    this.player.party[this.pokemonOption].canApplyItem(this.selectedItem)
                                );
                                if (this.player.party[this.pokemonOption].canApplyItem(this.selectedItem)) {
                                    const result = this.player.party[this.pokemonOption].applyItem(
                                        this.selectedItem
                                    );
                                    if (result.applicationComplete) {
                                        this.overworldText = result.applicationText;
                                        this.stateQueue.push(HEALTH_ITEM_APPLIED);
                                    }
                                    return result.applicationComplete;
                                } else {
                                    this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                                }
                            }
                            return true;
                        },
                    })
                );
                break;
            case APPLY_EV_ITEM_TO_RECIPIENT:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            if (this.player.party[this.pokemonOption].canApplyItem(this.selectedItem)) {
                                const result = this.player.party[this.pokemonOption].applyItem(
                                    this.selectedItem
                                );
                                if (result.applicationComplete) {
                                    this.overworldText = result.applicationText;
                                    this.stateQueue.push(EV_ITEM_APPLIED);
                                } else {
                                    this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                                }
                            } else {
                                this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                            }
                            return true;
                        },
                    })
                );
                break;
            case APPLY_RARE_CANDY:
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            const pokemonToLevelUp = this.player.party[this.pokemonOption];
                            if (pokemonToLevelUp.canApplyItem(this.selectedItem)) {
                                const result = pokemonToLevelUp.applyItem(this.selectedItem);
                                if (result.applicationComplete) {
                                    this.stateQueue.push(RARE_CANDY_APPLIED);
                                }
                                return result.applicationComplete;
                            } else {
                                this.stateQueue.push(IT_WONT_HAVE_ANY_EFFECT);
                            }
                        },
                        endAction: () => {
                            this.player.useItemV2(this.selectedItem.id);
                        },
                    })
                );

                break;
            case RARE_CANDY_APPLIED:
                break;
            case LEVEL_UP_POKEMON:
                this.readText(
                    `${this.player.party[this.pokemonOption].name} grew to level ${
                        this.player.party[this.pokemonOption].level
                    }!`
                );
                this.finishReading();
                this.script(() => {
                    this.context.currentPokemon = this.player.party[this.pokemonOption];
                    if (this.player.party[this.pokemonOption].hasNewMoveAvailable()) {
                        this.context.learnedMoveState = BAG;
                        this.context.learnedMoveSource = 'LEVEL_UP';
                        this.context.currentMove =
                            this.player.party[this.pokemonOption].getNextLearnableMoveForCurrentLevel();
                    }
                });
                break;
            case MOVE_ITEM_APPLIED:
                this.readText('The selected move was restored!');
                this.finishReading();
                break;
            case HEALTH_ITEM_APPLIED: {
                let healAmount = 0;
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            const pokemonToHeal = this.player.party[this.pokemonOption];
                            const targetHealAmount =
                                this.selectedItem.id === 'revive'
                                    ? Math.round(pokemonToHeal.stats.maxHp / 2)
                                    : this.selectedItem.healAmount;

                            if (
                                !!pokemonToHeal.status1 &&
                                this.selectedItem.healStatus?.includes(pokemonToHeal.status1.id)
                            ) {
                                pokemonToHeal.status1 = null;
                            }

                            if (
                                healAmount < targetHealAmount &&
                                pokemonToHeal.stats.hp < pokemonToHeal.stats.maxHp
                            ) {
                                pokemonToHeal.stats.hp += 1;
                                healAmount += 1;
                            } else {
                                return true;
                            }
                        },
                        endAction: () => {
                            this.player.useItemV2(this.selectedItem.id);
                        },
                    })
                );
                this.readText("Pokemon's health was restored!");
                this.finishReading();
                this.stateQueue.push(BAG);
                break;
            }
            case EV_ITEM_APPLIED: {
                this.actions.push(
                    new OverworldAction({
                        action: () => true,
                        endAction: () => {
                            this.player.useItemV2(this.selectedItem.id);
                        },
                    })
                );
                this.readText(this.overworldText);
                this.finishReading();
                this.stateQueue.push(BAG);
                break;
            }
            case IT_WONT_HAVE_ANY_EFFECT:
                this.readText("It won't have any effect...!");
                this.finishReading();
                break;
            case APPLY_HM_TO_RECIPIENT:
                this.context.currentPokemon = this.player.party[this.pokemonOption];
                this.context.currentMove = this.selectedItem.move;
                this.context.learnedMoveState = BAG;
                this.context.learnedMoveSource = 'HM';
                break;
            case NEW_MOVE_AVAILABLE:
                if (this.context.currentPokemon.hasEmptyMoveSlot()) {
                    this.actions.push(
                        new OverworldAction({
                            action: () => {
                                this.context.currentPokemon.learnMove(this.context.currentMove);
                                this.stateQueue.push(BAG);
                                return true;
                            },
                        })
                    );
                    this.readText(
                        `${this.context.currentPokemon.name} learned ${this.context.currentMove.name}!`
                    );
                    this.script(() => {
                        this.context.currentMove = null;
                    });
                    this.finishReading();
                } else {
                    this.readText(
                        `${this.context.currentPokemon.name} wants to learn the move ${this.context.currentMove.name}.`
                    );
                    this.continueReading();
                    this.readText(`But ${this.context.currentPokemon.name} already knows 4 moves.`);
                    this.continueReading();
                    this.readText(
                        `Should a move be deleted to make room for ${this.context.currentMove.name}?`
                    );
                    this.autoContinueReading();
                    this.askYesOrNo();
                }
                break;
            case CONFIRM_LEARN_NEW_MOVE:
                this.readText('Which move should be forgotten?');
                this.finishReading();

                break;
            case CHOOSE_MOVE_TO_FORGET:
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            this.summaryMoveDetailOption = 0;
                        },
                        action: () => {
                            if (this.awaitCancelInput()) {
                                this.shouldCancel = true;
                                return true;
                            }
                            this.summaryMoveDetailOption = this.awaitVerticalOptionInput(
                                this.summaryMoveDetailOption,
                                5
                            ).currentOption;
                            return this.awaitVerticalOptionInput(this.summaryMoveDetailOption, 5).selected;
                        },
                        endAction: () => {
                            if (this.summaryMoveDetailOption === 4) {
                                this.stateQueue.push(STOP_LEARNING_NEW_MOVE);
                            }
                        },
                    })
                );
                break;
            case FORGOT_MOVE:
                this.readText(
                    `1... 2... 3... and... Poof! ${this.context.currentPokemon.name} forgot ${
                        this.context.currentPokemon.moves[this.summaryMoveDetailOption].name
                    }!`
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.context.currentPokemon.moves[this.summaryMoveDetailOption] = null;
                            this.context.currentPokemon.learnMove(this.context.currentMove);
                            return true;
                        },
                    })
                );
                this.continueReading();
                break;
            case LEARNED_NEW_MOVE:
                this.readText(
                    `${this.context.currentPokemon.name} learned ${this.context.currentMove.name}!`
                );
                this.script(() => {
                    this.context.currentMove = null;
                });
                this.finishReading();
                break;
            case STOP_LEARNING_NEW_MOVE:
                this.readText(`Stop trying to learn ${this.context.currentMove.name}?`);
                this.autoContinueReading();
                this.askYesOrNo();
                break;
            case DID_NOT_LEARN_NEW_MOVE:
                this.readText(
                    `${this.player.party[this.pokemonOption].name} did not learn ${
                        this.context.currentMove.name
                    }.`
                );
                this.script(() => {
                    this.context.currentMove = null;
                });
                this.finishReading();
                break;
            case SAVE:
                this.readText('Saving game...');
                this.actions.push(
                    new OverworldAction({
                        isAsync: true,
                        action: async () => {
                            await gameSaveManager.saveGame(this);
                            // Reset auto-save timer after manual save
                            this.lastAutoSaveTime = Date.now();
                            return true;
                        },
                    })
                );
                this.readText('Save complete!');
                this.finishReading();
                break;
            case LOAD_GAME:
                this.darkenScreen();
                // Transition to LOADING state to prevent auto-save during loading
                this.stateQueue.push(LOADING);
                this.actions.push(
                    new OverworldAction({
                        isAsync: true, // Mark as async so the state machine properly awaits it
                        action: async () => {
                            await gameSaveManager.loadGame();
                            // GameSaveManager will transition to IDLE when loading is complete
                            return true;
                        },
                    })
                );
                break;
            case EXIT:
                break;
            case SEEN_BY_TRAINER:
                this.actions = [];
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            const currentNPC = this.context.npcSeenBy;
                            currentNPC.stateMachine.stateQueue.push(PLAYER_SEEN);
                            this.player.overworldSprite.moving = false;
                            this.player.running = false;
                            return true;
                        },
                        action: () => {
                            // NPC drains its own queue while walking; APPROACHED_PLAYER pushes
                            // APPROACHED_BY_TRAINER onto this (overworld) queue when ready.
                            return this.stateQueue.length > 0;
                        },
                    })
                );
                break;
            case APPROACHED_BY_TRAINER:
                this.actions = [];
                this.actions.push(
                    new OverworldAction({
                        startAction: () => {
                            switch (this.context.npcSeenBy.direction) {
                                case UP:
                                    this.player.direction = DOWN;
                                    break;
                                case LEFT:
                                    this.player.direction = RIGHT;
                                    break;
                                case DOWN:
                                    this.player.direction = UP;
                                    break;
                                case RIGHT:
                                    this.player.direction = LEFT;
                                    break;
                            }
                            this.overworldText = this.context.npcSeenBy.preBattleText;
                            this.overworldTextSpeaker = this.context.npcSeenBy.name || '';
                        },
                        action: () => {
                            return KPI_L && this.cursor >= this.overworldText.length;
                        },
                    })
                );
                this.actions.push(
                    new OverworldAction({
                        action: () => {
                            this.cursor = this.overworldText.length;
                            return KPI_L || KPI_K;
                        },
                        endAction: () => {
                            this.overworldText = '';
                            this.overworldTextSpeaker = '';
                            this.adjacentObjects[this.player.direction]?.endInteraction();
                        },
                    })
                );
                break;
            case USE_FLASH:
                this.readText("It's really dark in here...");
                if (this.player.hasFlash()) {
                    this.continueReading();
                    this.readText(`${this.player.name} used Flash!`);
                    this.finishReading();
                    useFlash();
                } else {
                    this.finishReading();
                }
                this.script(() => {
                    this.currentMap.flashWasAttempted = true;
                });
                break;
            case OVERWORLD_EVENT:
                this.script(() => {
                    this.player.moving = false;
                    this.GUI.sprites.player.moving = false;
                });
                this.context.currentEvent.runActions();
                break;
            default:
                this.currentState = IDLE;
        }
        this.actions.forEach((action) => {
            action.stateMachine = this;
        });
    }

    clearActions() {
        this.actions = [];
    }

    /**
     * Creates a parallel action executor that executes multiple actions simultaneously.
     * @param {...*} actions - Actions to execute in parallel
     * @returns {Object} A parallel action executor with execute() and ended properties
     */
    parallel(...actions) {
        // Flatten the actions array in case arrays were passed as arguments
        const actionsArray = actions.flat();

        const executor = {
            _isParallel: true,
            actions: actionsArray,
            ended: false,
        };

        executor.execute = () => {
            if (executor.ended) {
                return;
            }

            // Execute all actions in parallel
            executor.actions.forEach((action) => {
                // Handle nested parallel wrappers, series wrappers, or arrays
                if (action && typeof action === 'object' && action._isParallel) {
                    // It's a parallel wrapper - execute it
                    if (!action.ended) {
                        action.execute();
                    }
                } else if (action && typeof action === 'object' && action._isSeries) {
                    // It's a series wrapper - execute it
                    if (!action.ended) {
                        action.execute();
                    }
                } else if (Array.isArray(action)) {
                    // It's an array - execute sequentially (arrays are sequential by default)
                    if (!action._sequentialExecutor) {
                        action._sequentialExecutor = this._createSequentialExecutor(action);
                    }
                    action._sequentialExecutor.execute();
                    action.ended = action._sequentialExecutor.ended;
                } else {
                    // It's a regular action
                    if (!action.ended) {
                        // Handle async actions
                        if (action.isAsync) {
                            if (!action.isExecuting) {
                                // Start async execution
                                action.execute().catch((error) => {
                                    console.error(
                                        'Error executing async action in parallel executor:',
                                        error
                                    );
                                    action.ended = true;
                                });
                            }
                        } else {
                            // Synchronous action
                            action.execute();
                        }
                    }
                }
            });

            // Check if all actions are ended
            executor.ended = executor.actions.every((action) => {
                if (action && typeof action === 'object' && action._isParallel) {
                    return action.ended;
                } else if (action && typeof action === 'object' && action._isSeries) {
                    return action.ended;
                } else if (Array.isArray(action)) {
                    return action._sequentialExecutor ? action._sequentialExecutor.ended : false;
                }
                return action.ended;
            });
        };

        return executor;
    }

    /**
     * Creates a series action executor that executes multiple actions sequentially.
     * @param {...*} actions - Actions to execute in series
     * @returns {Object} A series action executor with execute() and ended properties
     */
    series(...actions) {
        // Flatten the actions array in case arrays were passed as arguments
        const actionsArray = actions.flat();

        // Create a sequential executor for the actions
        const executor = this._createSequentialExecutor(actionsArray);
        executor._isSeries = true;

        return executor;
    }

    /**
     * Creates a sequential executor for an array of actions.
     * @param {Array} actionsArray - Array of actions to execute sequentially
     * @returns {Object} A sequential executor with execute() and ended properties
     */
    _createSequentialExecutor(actionsArray) {
        const executor = {
            actions: actionsArray,
            currentIndex: 0,
            currentExecutor: null,
            ended: false,
        };

        executor.execute = () => {
            if (executor.ended) {
                return;
            }

            // Handle empty array
            if (executor.actions.length === 0) {
                executor.ended = true;
                return;
            }

            // Check if we've completed all actions
            if (executor.currentIndex >= executor.actions.length) {
                executor.ended = true;
                return;
            }

            const currentAction = executor.actions[executor.currentIndex];

            // Handle different action types
            if (currentAction && typeof currentAction === 'object' && currentAction._isParallel) {
                // It's a parallel wrapper
                if (!executor.currentExecutor) {
                    executor.currentExecutor = currentAction;
                }
                executor.currentExecutor.execute();

                if (executor.currentExecutor.ended) {
                    executor.currentIndex++;
                    executor.currentExecutor = null;
                }
            } else if (currentAction && typeof currentAction === 'object' && currentAction._isSeries) {
                // It's a series wrapper
                if (!executor.currentExecutor) {
                    executor.currentExecutor = currentAction;
                }
                executor.currentExecutor.execute();

                if (executor.currentExecutor.ended) {
                    executor.currentIndex++;
                    executor.currentExecutor = null;
                }
            } else if (Array.isArray(currentAction)) {
                // It's a nested array - execute sequentially
                if (!executor.currentExecutor) {
                    executor.currentExecutor = this._createSequentialExecutor(currentAction);
                }
                executor.currentExecutor.execute();

                if (executor.currentExecutor.ended) {
                    executor.currentIndex++;
                    executor.currentExecutor = null;
                }
            } else {
                // It's a regular action
                if (!currentAction.ended) {
                    // Handle async actions
                    if (currentAction.isAsync) {
                        if (!currentAction.isExecuting) {
                            // Start async execution
                            currentAction.execute().catch((error) => {
                                console.error('Error executing async action in sequential executor:', error);
                                currentAction.ended = true;
                            });
                        }
                    } else {
                        // Synchronous action
                        currentAction.execute();
                    }
                }

                if (currentAction.ended) {
                    executor.currentIndex++;
                }
            }

            // Update ended status
            executor.ended = executor.currentIndex >= executor.actions.length;
        };

        return executor;
    }

    updateStateHistory() {
        if (this.skipStateHistory) {
            this.skipStateHistory = false;
            return;
        }
        this.stateHistory.unshift(this.currentState);
        if (this.stateHistory.length >= 10) {
            this.stateHistory.pop();
        }
    }

    goToPreviousState() {
        this.stateQueue.push(this.stateHistory.shift());
        this.skipStateHistory = true;
    }

    transitionToNextState() {
        if (this.currentState !== BATTLE) {
            console.log(`-- Ending State: ${this.currentState} --`);
        }
        this.updateStateHistory();
        if (this.stateQueue.length > 0) {
            this.currentState = this.stateQueue.shift();
            console.log(`-- Starting From Queue: ${this.currentState} -- `);
            this.setupActionsForCurrentState();
            return;
        }
        this.previousState = this.currentState;
        switch (this.currentState) {
            case INTRO_CREDITS:
                this.currentState = CHECK_AUTH;
                break;
            case VERIFY_ACCESS_CODE:
                this.currentState = VERIFY_ACCESS_CODE;
                break;
            case USE_KEYBOARD:
                this.currentState = IDLE;
                break;
            case SET_NICKNAME:
                break;
            case LOADING:
                // Loading state - wait for all async operations to complete
                // This state prevents auto-save during the loading transition period
                // Transition to IDLE will happen when loading is complete (handled in GameSaveManager)
                break;
            case IDLE:
                this.undarkenScreen();
                // Update activity time when player interacts (presses L)
                if (KPI_L) {
                    this.lastPlayerActivityTime = Date.now();
                }
                if (this.shouldChangeDirection()) {
                    this.player.direction = this.player.requestedDirection;

                    let currentEncounterRate = 0;
                    if (this.adjacentObjects.center instanceof BattleZone) {
                        currentEncounterRate = this.currentLocation.encounterRate;
                        this.adjacentObjects.center.ruffleGrass();
                    }

                    // Check for wild battle encounter (skip if cheat is enabled)
                    if (!this.shouldSkipWildBattles() && Math.random() < currentEncounterRate) {
                        this.stateQueue.push(START_BATTLE);
                        return true;
                    }
                }
                if (this.canMove()) {
                    this.currentState = START_MOVING;
                } else {
                    this.currentState = COLLISION;
                }
                break;
            case OVERWORLD_EVENT:
                if (this.context.currentEvent === null) {
                    this.currentState = IDLE;
                    console.warn(
                        'Attempting to transition from OVERWORLD_EVENT without a currentEvent defined in the context.'
                    );
                    break;
                }
                if (this.context.currentEvent.autoComplete) {
                    this.context.currentEvent.complete = true;
                }
                this.currentState = this.context.currentEvent.nextState || IDLE;
                this.context.currentEvent = null;
                break;
            case CHANGE_DIRECTION:
                this.currentState = IDLE;
                break;
            case START_MOVING:
                // Update activity time when starting to move
                this.lastPlayerActivityTime = Date.now();
                this.currentState = MOVING;
                if (this.adjacentObjects.center instanceof BattleZone) {
                    this.adjacentObjects.center.ruffleGrass();
                }
                break;
            case MOVING:
                // Keep updating activity time while moving
                this.lastPlayerActivityTime = Date.now();
                this.currentState = END_MOVING;
                break;
            case READ_TEXT_SOURCE:
                this.currentState = IDLE;
                break;
            case BOOT_UP_PC:
                this.currentState = MANAGE_POKEMON;
                break;
            case RELEASE_POKEMON:
                this.currentState = MANAGE_POKEMON;
                break;
            case MANAGE_POKEMON:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    if (this.pcMenu.partyList.filter((p) => p !== null).length > 0) {
                        this.currentState = SHUT_DOWN_PC;
                        break;
                    }
                    this.currentState = CANT_LEAVE_PC_WITHOUT_POKEMON;
                    break;
                }
                this.currentState = PC_POKEMON_PRESELECTED;
                break;
            case CANT_LEAVE_PC_WITHOUT_POKEMON:
                this.currentState = MANAGE_POKEMON;
                break;
            case PC_POKEMON_PRESELECTED:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = MANAGE_POKEMON;
                    break;
                }

                if (this.pcMenu.preselectionOption === 0) {
                    this.currentState = MANAGE_POKEMON_WITH_SELECTED;
                    break;
                } else if (this.pcMenu.preselectionOption === 2) {
                    break;
                } else if (this.pcMenu.preselectionOption === 3) {
                    break;
                } else {
                    this.currentState = MANAGE_POKEMON;
                }
                break;
            case MANAGE_POKEMON_WITH_SELECTED:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = MANAGE_POKEMON;
                }
                if (!(this.pcMenu.selectedPokemon instanceof Pokemon)) {
                    this.currentState = MANAGE_POKEMON;
                }
                break;
            case SHUT_DOWN_PC:
                this.currentState = IDLE;
                break;
            case INTERACT_WITH_HM_TREE:
                this.currentState = IDLE;
                break;
            case INTERACT_WITH_HM_ROCK:
                this.currentState = IDLE;
                break;
            case ACQUIRE_OVERWORLD_ITEM:
                this.currentState = IDLE;
                break;
            case END_MOVING:
                this.currentState = IDLE;
                break;
            case COLLISION:
                this.currentState = END_MOVING;
                break;
            case START_BATTLE:
                this.currentState = BATTLE;
                break;
            case BATTLE:
                break;
            case END_BATTLE: {
                if (this.player.whitedOut()) {
                    if (this.context?.upcomingBattleOptions?.isStaticEncounter) {
                        this.context.upcomingBattleOptions.pokemon.staticEncounter.reset();
                    }
                    this.player.healParty();
                    if (this.trainerBattleHistory.length > 0) {
                        this.trainerBattleHistory[0].resetToSourcePosition();
                        const npcSM = this.trainerBattleHistory[0].stateMachine;
                        npcSM.actions = [];
                        npcSM.currentAction = null;
                        npcSM.stateQueue = [IDLE];
                        this.context.npcSeenBy = null;
                    }
                    this.player.biking = false;
                    if (this.availableMaps[this.player.whiteoutLocation.mapIdentifier] === undefined) {
                        this.currentMap = availableMaps[this.player.whiteoutLocation.mapIdentifier];
                    } else {
                        this.currentMap = this.availableMaps[this.player.whiteoutLocation.mapIdentifier];
                    }
                    this.player.resetToWhiteoutLocation();
                    this.GUI.setup();
                } else {
                    if (this.context?.upcomingBattleOptions?.isStaticEncounter) {
                        this.context.upcomingBattleOptions.pokemon.staticEncounter.conclude();
                    }
                }

                let evolutionAvailable = false;
                this.player.party.forEach((pokemon) => {
                    if (pokemon.checkCanEvolveViaLevelUp()) {
                        evolutionAvailable = true;
                    }
                });
                if (evolutionAvailable) {
                    this.currentState = EVOLVE_POKEMON;
                } else {
                    this.currentState = IDLE;
                }

                this.context.upcomingBattleOptions = null;
                break;
            }
            case EVOLVE_POKEMON:
                this.currentState = IDLE;
                break;
            case PAUSE_MENU:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = IDLE;
                    break;
                }
                this.currentState = this.pauseMenu.getStateForCurrentOption();
                break;
            case OPTIONS_MENU:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = PAUSE_MENU;
                    break;
                }
                // Options menu doesn't transition automatically
                break;
            case POKEDEX:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = PAUSE_MENU;
                }
                break;
            case INTERACT_WITH_MART_LOCATION:
                this.currentState = CHOOSE_MART_OPTION;
                break;
            case CHOOSE_MART_OPTION:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = END_MART_INTERACTION;
                    break;
                }
                switch (this.martMenuOption) {
                    case 0: // Buy
                        this.currentState = BUY_FROM_MART;
                        break;
                    case 1: // Sell
                        this.currentState = SELL_TO_MART;
                        break;
                    case 2: // See Ya!
                        this.currentState = END_MART_INTERACTION;
                        break;
                    default:
                        this.currentState = IDLE;
                }
                break;
            case BUY_FROM_MART:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = MART_ANYTHING_ELSE;
                    break;
                }
                this.currentState = MART_OPTION_PRESELECTED;
                break;
            case MART_OPTION_PRESELECTED:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = END_MART_INTERACTION;
                    break;
                }
                this.currentState = MART_OPTION_SELECT_AMOUNT;
                break;
            case MART_OPTION_SELECT_AMOUNT:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = END_MART_INTERACTION;
                    break;
                }
                if (this.martCurrentCost > this.player.money) {
                    this.currentState = MART_NOT_ENOUGH_MONEY;
                    break;
                }
                this.currentState = MART_ITEM_AMOUNT_SELECTED;
                break;
            case MART_NOT_ENOUGH_MONEY:
                this.currentState = BUY_FROM_MART;
                break;
            case MART_ITEM_AMOUNT_SELECTED:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = BUY_FROM_MART;
                }
                if (this.yesOrNoOption === 0) {
                    this.currentState = MART_ITEM_AMOUNT_CONFIRMED;
                } else {
                    this.currentState = BUY_FROM_MART;
                }
                break;

            case MART_ITEM_AMOUNT_CONFIRMED:
                this.currentState = BUY_FROM_MART;
                break;
            case MART_ANYTHING_ELSE:
                this.currentState = CHOOSE_MART_OPTION;
                break;
            case SELL_TO_MART:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = MART_ANYTHING_ELSE;
                    break;
                }
                this.currentState = MART_SELL_AMOUNT;
                break;
            case MART_SELL_AMOUNT:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = SELL_TO_MART;
                    break;
                }
                this.currentState = MART_SELL_AMOUNT_CONFIRMATION;
                break;
            case MART_SELL_AMOUNT_CONFIRMATION:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = SELL_TO_MART;
                    break;
                }
                if (this.yesOrNoOption === 0) {
                    this.currentState = MART_ITEMS_SOLD;
                    break;
                }
                this.currentState = SELL_TO_MART;
                break;
            case MART_ITEMS_SOLD:
                this.currentState = SELL_TO_MART;
                break;
            case END_MART_INTERACTION:
                this.currentState = IDLE;
                break;
            case TRAINER_CARD:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = PAUSE_MENU;
                }
                break;
            case POKEMON:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = PAUSE_MENU;
                    break;
                }
                if (this.pokemonOption === this.player.party.length) {
                    this.currentState = PAUSE_MENU;
                    break;
                }
                this.currentState = POKEMON_PRESELECTED;
                break;
            case SWITCH_POSITIONS_WITH_WHO:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = POKEMON;
                    break;
                }
                this.currentState = POKEMON_SWITCH_POSITIONS;
                break;
            case POKEMON_SWITCH_POSITIONS:
                this.currentState = POKEMON;
                break;
            case POKEMON_PRESELECTED:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = POKEMON;
                    break;
                }
                if (this.pokemonDetailOption === 0) {
                    this.currentState = POKEMON_SUMMARY;
                } else if (this.pokemonDetailOption === 1) {
                    this.currentState = SWITCH_POSITIONS_WITH_WHO;
                } else if (this.pokemonDetailOption === 2) {
                    this.currentState = DO_WHAT_WITH_ITEM;
                } else if (this.pokemonDetailOption === 3) {
                    this.currentState = SET_NICKNAME;
                } else if (this.pokemonDetailOption === 4) {
                    this.currentState = POKEMON;
                }
                break;
            case DO_WHAT_WITH_ITEM:
                console.log('DO_WHAT_WITH_ITEM');
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = POKEMON_PRESELECTED;
                    break;
                }
                if (this.pokemonItemOption === 0) {
                    this.currentState = BAG;
                    // this.stateQueue.push(BAG);
                    this.stateQueue.push(ITEM_GIVEN_TO_POKEMON);
                    this.stateQueue.push(POKEMON);
                    break;
                }
                if (this.pokemonItemOption === 1) {
                    // Take item flow
                    this.currentState = ITEM_TAKEN_FROM_POKEMON;
                    break;
                }
                if (this.pokemonItemOption === 2) {
                    this.currentState = POKEMON;
                    break;
                }
                break;
            // If option 1 (Give) go to give flow
            // If option 2 (Take) go to take flow
            // If option 3 (Cancel) cancel out
            case ITEM_TAKEN_FROM_POKEMON:
                this.currentState = POKEMON;
                break;

            case POKEMON_SUMMARY:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    return;
                }
                this.currentState = IDLE;
                break;
            case POKEMON_MOVE_DETAIL:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = POKEMON_SUMMARY;
                    break;
                }
                if (this.moveDetailOption === 4) {
                    this.currentState = POKEMON_SUMMARY;
                }
                break;
            case BAG:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = PAUSE_MENU;
                    break;
                }
                if (this.selectedItem.isKeyItem()) {
                    this.currentState = KEY_ITEM_PRESELECTED;
                    break;
                }
                this.currentState = BAG_ITEM_PRESELECTED;
                break;
            case KEY_ITEM_PRESELECTED:
                if (
                    this.shouldCancel ||
                    this.bagItemDetailOption === this.selectedItem.overworldOptions.length - 1
                ) {
                    this.shouldCancel = false;
                    this.currentState = BAG;
                    break;
                } else if (this.selectedItem.overworldOptions[this.bagItemDetailOption] === 'Use') {
                    this.currentState = USE_KEY_ITEM;
                    break;
                }
                break;
            case BAG_ITEM_PRESELECTED:
                if (
                    this.shouldCancel ||
                    this.bagItemDetailOption === this.selectedItem.overworldOptions.length - 1
                ) {
                    this.shouldCancel = false;
                    this.currentState = BAG;
                    break;
                } else if (this.selectedItem.overworldOptions[this.bagItemDetailOption] === 'Give') {
                    this.currentState = SELECT_ITEM_RECIPIENT;
                } else if (this.selectedItem.overworldOptions[this.bagItemDetailOption] === 'Use') {
                    this.currentState = SELECT_ITEM_CONSUMER;
                } else {
                    this.currentState = BAG;
                }
                break;
            case SELECT_ITEM_RECIPIENT:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = BAG;
                    break;
                }
                if (this.pokemonOption === this.player.party.length) {
                    this.currentState = BAG;
                    break;
                }
                this.currentState = ITEM_GIVEN_TO_POKEMON;
                break;
            case ITEM_GIVEN_TO_POKEMON:
                this.currentState = BAG;
                break;
            case SELECT_ITEM_CONSUMER:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = BAG;
                    break;
                }
                if (this.pokemonOption === this.player.party.length) {
                    this.currentState = BAG;
                    break;
                }
                if (this.player.party[this.pokemonOption].canApplyItem(this.selectedItem)) {
                    if (
                        this.selectedItem.isMoveItem() ||
                        ['pp_up', 'pp_max'].includes(this.selectedItem.id)
                    ) {
                        this.currentState = SELECT_ITEM_CONSUMER_MOVE;
                        break;
                    } else if (this.selectedItem.isRareCandy()) {
                        this.currentState = APPLY_RARE_CANDY;
                    } else if (
                        this.selectedItem.isHealingItem() ||
                        (berryItemIds.includes(this.selectedItem.id) &&
                            (this.selectedItem.healAmount !== null && this.selectedItem.healAmount !== undefined ||
                                this.selectedItem.healStatus?.length > 0 ||
                                pinchBerryItemIds.includes(this.selectedItem.id)))
                    ) {
                        this.currentState = APPLY_ITEM_TO_RECIPIENT;
                    } else if (this.selectedItem.isEVItem()) {
                        this.currentState = APPLY_EV_ITEM_TO_RECIPIENT;
                    } else {
                        this.currentState = APPLY_HM_TO_RECIPIENT;
                    }
                } else {
                    this.currentState = IT_WONT_HAVE_ANY_EFFECT;
                }
                break;
            case SELECT_ITEM_CONSUMER_MOVE:
                if (this.shouldCancel) {
                    this.shouldCancel = false;
                    this.currentState = SELECT_ITEM_CONSUMER;
                    break;
                }
                this.currentState = APPLY_ITEM_TO_MOVE;
                break;
            case APPLY_ITEM_TO_MOVE:
                this.currentState = BAG;
                break;
            case LEARNED_NEW_MOVE:
                if (this.context.learnedMoveState === 'BAG') {
                    this.currentState = BAG;
                }
                break;
            case CURRENT_MOVES_FULL:
                break;
            case APPLY_RARE_CANDY:
                this.currentState = RARE_CANDY_APPLIED;
                break;
            case RARE_CANDY_APPLIED:
                this.currentState = LEVEL_UP_POKEMON;
                break;
            case LEVEL_UP_POKEMON:
                if (this.context.currentMove !== null && this.context.currentMove !== undefined) {
                    this.currentState = NEW_MOVE_AVAILABLE;
                    if (this.player.party[this.pokemonOption].checkCanEvolveViaLevelUp()) {
                        this.currentState = EVOLVE_POKEMON;
                        this.stateQueue.push(NEW_MOVE_AVAILABLE);
                        break;
                    }
                    break;
                }
                if (this.player.party[this.pokemonOption].checkCanEvolveViaLevelUp()) {
                    this.currentState = EVOLVE_POKEMON;
                    break;
                }
                this.currentState = BAG;
                break;
            case APPLY_ITEM_TO_RECIPIENT:
                this.currentState = BAG;
                break;
            case APPLY_EV_ITEM_TO_RECIPIENT:
                this.currentState = BAG;
                break;
            case EV_ITEM_APPLIED:
                this.currentState = BAG;
                break;
            case IT_WONT_HAVE_ANY_EFFECT:
                this.currentState = BAG;
                break;
            case APPLY_HM_TO_RECIPIENT:
                this.currentState = NEW_MOVE_AVAILABLE;
                break;
            case NEW_MOVE_AVAILABLE:
                if (this.yesOrNoOption === 0) {
                    this.currentState = CONFIRM_LEARN_NEW_MOVE;
                } else {
                    this.currentState = STOP_LEARNING_NEW_MOVE;
                }
                break;
            case CONFIRM_LEARN_NEW_MOVE:
                this.currentState = CHOOSE_MOVE_TO_FORGET;
                break;
            case CHOOSE_MOVE_TO_FORGET:
                if (this.shouldCancel) {
                    this.currentState = STOP_LEARNING_NEW_MOVE;
                    break;
                }
                this.currentState = FORGOT_MOVE;
                break;
            case FORGOT_MOVE:
                this.currentState = LEARNED_NEW_MOVE;
                break;
            // case LEARNED_NEW_MOVE:
            //     if (this.context.learnedMoveState) {
            //         this.currentState = this.context.learnedMoveState;
            //         this.context.learnedMoveState = null;
            //         break;
            //     }
            //     this.currentState = IDLE;
            //     break;
            case STOP_LEARNING_NEW_MOVE:
                if (this.yesOrNoOption === 0) {
                    this.currentState = DID_NOT_LEARN_NEW_MOVE;
                } else {
                    if (this.context.learnedMoveSource === 'LEVEL_UP') {
                        this.currentState = NEW_MOVE_AVAILABLE;
                    } else if (this.context.learnedMoveSource === 'HM') {
                        this.currentState = APPLY_HM_TO_RECIPIENT;
                    }
                }
                break;
            case DID_NOT_LEARN_NEW_MOVE:
                if (this.context.learnedMoveState) {
                    this.currentState = this.context.learnedMoveState;
                    this.context.learnedMoveState = null;
                    this.shouldCancel = false;
                    break;
                }
                this.currentState = IDLE;
                break;
            case SAVE:
                this.currentState = IDLE;
                break;
            case EXIT:
                this.currentState = IDLE;
                break;
            case SEEN_BY_TRAINER:
                break;
            case APPROACHED_BY_TRAINER:
                this.currentState = START_TRAINER_BATTLE;
                break;
            case START_TRAINER_BATTLE:
                this.currentState = BATTLE;
                break;
            case WARP_TO_LOCATION:
                this.currentState = IDLE;
                break;
            case USE_FLASH:
                this.currentState = IDLE;
                break;
            case INTERACT_WITH_NPC:
                this.currentState = IDLE;
                break;
            case CANT_USE_ITEM:
                this.currentState = BAG;
                break;
            case TOWN_MAP:
                this.shouldCancel = false;
                this.currentState = BAG;
                break;
            case TOWN_MAP_LOCATION_DETAIL:
                this.currentState = TOWN_MAP;
                break;
            default:
                console.warn(`Unknown state: ${this.currentState}. Falling back to IDLE.`);
                this.currentState = IDLE;
        }
        this.setupActionsForCurrentState();
    }
}
